import { jsxs as f, jsx as l } from "react/jsx-runtime";
import B, { useState as ve, useRef as de, useEffect as xe, forwardRef as C } from "react";
const Se = {
  Primary: {
    value: "rgba(38, 38, 38, 1)",
    type: "color",
    description: "구)B85 / ㅌㅅㅌ.ㅍㄹㅇㅁㄹ / 일반적인 텍스트나 아이콘의 색상으로 사용됩니다. 라지타이틀과 타이틀에서는 필수로 사용되고 있습니다."
  },
  PrimaryHovered: {
    value: "rgba(38, 38, 38, 0.9)",
    type: "color"
  },
  PrimaryPressed: {
    value: "rgba(38, 38, 38, 0.8)",
    type: "color"
  },
  Secondary: {
    value: "rgba(102, 102, 102, 1)",
    type: "color",
    description: "구)B60 / ㅌㅅㅌ.ㅅㅋㄷㄹ / Text.Primary 색상보다 조금 눌러진 색을 쓰고 싶을 떄 사용합니다."
  },
  Tertiary: {
    value: "rgba(66, 75, 76, 1)",
    type: "color",
    description: "구)DarkGR /  ㅌㅅㅌ.ㅌㅌㅇㄹ / Text.Primary를 사용했을 때 배경색과 대비차가 강할 경우 사용합니다. Primary와 Secondary를 우선 사용 후 밸런스가 안맞을 경우 사용해 주세요."
  },
  TertiaryHovered: {
    value: "rgba(66, 75, 76, 0.9)",
    type: "color"
  },
  TertiaryPressed: {
    value: "rgba(66, 75, 76, 0.8)",
    type: "color"
  },
  Support: {
    value: "rgba(153, 153, 153, 1)",
    type: "color",
    description: "구)B40 / ㅌㅅㅌ.ㅅㅍㅌ / 주로 부연설명에 사용되는 텍스트 및 아이콘 색상입니다."
  },
  SupportHovered: {
    value: "rgba(153, 153, 153, 0.9)",
    type: "color"
  },
  SupportPressed: {
    value: "rgba(153, 153, 153, 0.8)",
    type: "color"
  },
  Inactive: {
    value: "rgba(153, 153, 153, 1)",
    type: "color",
    description: "구)B40 / ㅌㅅㅌ.ㅇㅇㅌㅂ / 액티브/인액티브 상태에서 인엑티브 텍스트에 사용합니다. 예를들어 탭바에서 비활성화된 텍스트의 경우 이 색상을 사용합니다."
  },
  SupportIcon: {
    value: "rgba(204, 204, 204, 1)",
    type: "color",
    description: "구)B20 / ㅌㅅㅌ.ㅅㅍㅌㅇㅇㅋ / 아이콘이 힌트의 역할로 사용될 때 사용됩니다. 서포트 색상을 사용을 권하지만 화면의 밸런스가 맞지 않을경우 사용합니다. 디스에이블과 같은 색상이라 최대한 사용을 적게해야 합니다."
  },
  SupportIconHovered: {
    value: "rgba(204, 204, 204, 0.9)",
    type: "color"
  },
  SupportIconPressed: {
    value: "rgba(204, 204, 204, 0.8)",
    type: "color"
  },
  Disabled: {
    value: "rgba(0, 0, 0, 0.2)",
    type: "color",
    description: "구)B20 / ㅌㅅㅌ.ㄷㅅㅇㅇㅂ / 아이콘 또는 텍스트가 Disabled 된 경우 사용합니다."
  },
  AccentDisabled: {
    value: "rgba(118, 130, 131, 1)",
    type: "color",
    description: "Coolgrey 100 / ㅌㅅㅌ ㅇㅅㅌㄷㅅㅇㅇㅂㄷ / 강조된 텍스트 색상의 디스에이블에 사용합니다."
  },
  OnTint: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W / ㅌㅅㅌ.ㅇㅌㅌ / 배경에 명도가 짙은 색이 깔리지만, 테마가 바뀌어도 배경색이 변하지 않는 경우 사용합니다. 예를 들면 배경색으로 청연블루95 색상이 사용된 경우 테마가 변하더라도 청연블루95 색상은 유지되기 때문에 텍스트의 색상도 그대로 사용합니다."
  },
  OnTintHovered: {
    value: "rgba(255, 255, 255, 0.9)",
    type: "color"
  },
  OnTintPressed: {
    value: "rgba(255, 255, 255, 0.8)",
    type: "color"
  },
  OnTintSubdued: {
    value: "rgba(255, 255, 255, 0.6)",
    type: "color",
    description: "ㅌㅅㅌ.ㅇㅌㅌㅅㄷㄷ / Ontint의 색상이 강하거나 Inactive 상태에 사용합니다."
  },
  Accent: {
    value: "rgba(0, 190, 214, 1)",
    type: "color",
    description: "구)BU / ㅌㅅㅌ.ㅇㅅㅌ / 브랜드 색상 또는 강조해야하는 경우 가장 우선순위가 높은 색상입니다. 링크 또는 콜투액션에도 자주 사용됩니다."
  },
  AccentHovered: {
    value: "rgba(0, 190, 214, 0.9)",
    type: "color"
  },
  AccentPressed: {
    value: "rgba(0, 190, 214, 0.8)",
    type: "color"
  },
  AccentSubdued: {
    value: "rgba(26, 124, 136, 1)",
    type: "color",
    description: "구)DeepBU / ㅌㅅㅌ.ㅇㅅㅌㅅㄷㄷ / ACCENT 색상을 썼을 때 너무 강한 경우 AccentSubdued 색상을 사용합니다. 링크 또는 콜투액션에도 자주 사용됩니다."
  },
  AccentSubduedHovered: {
    value: "rgba(26, 124, 136, 0.9)",
    type: "color",
    description: `Interaction Color
`
  },
  AccentSubduedPressed: {
    value: "rgba(26, 124, 136, 0.8)",
    type: "color",
    description: `Interaction Color
`
  },
  Inverse: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W / ㅌㅅㅌ.ㅇㅂㅅ 테마가 바뀌게 되었을 때 배경색 또한 바뀌게 되는 경우 사용됩니다. 특히 배경색이 대비차를 이용해 강조를 하고 있는 색상일 경우 사용합니다. 예를들면 토스트(스낵바)에서는 대비되는 배경 색을 쓰고 있기에 테마가 바뀌면 배경색이 변하게 됩니다. 이럴 경우 인버스 색상을 사용해 주세요."
  },
  InverseHovered: {
    value: "rgba(255, 255, 255, 0.9)",
    type: "color"
  },
  InversePressed: {
    value: "rgba(255, 255, 255, 0.8)",
    type: "color"
  },
  InverseSubdued: {
    value: "rgba(255, 255, 255, 0.6)",
    type: "color",
    description: "ㅌㅅㅌ.ㅇㅂㅅㅅㄷㄷ / Inverse의 색상이 강한경우 사용해 주세요."
  },
  InverseAccent: {
    value: "rgba(9, 158, 177, 1)",
    type: "color",
    description: "구)DeepBU2 / ㅌㅅㅌ.ㅇㅂㅅㅇㅅㅌ / 인버스가 되어야하는 색상 중 강조하는 경우에 사용됩니다. 예를들어 테마를 바꾸게 되는경우 강조색이 다른색으로 전환되어야하는 경우 사용합니다."
  },
  Warning: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅌㅅㅌ.ㅇㄴ / 경고성 문구에 사용됩니다."
  },
  WarningHovered: {
    value: "rgba(249, 83, 83, 0.9)",
    type: "color"
  },
  WarningPressed: {
    value: "rgba(249, 83, 83, 0.8)",
    type: "color"
  },
  Error: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅌㅅㅌ.ㅇㄹ / Error 문구 또는 아이콘에서 사용합니다."
  }
}, Pe = {
  Primary: {
    value: "rgba(0, 190, 214, 1)",
    type: "color",
    description: "구)BU / ㅂㅌㅇ.ㅍㄹㅇㅁㄹ / Primary 색상의 Enabled 상태입니다."
  },
  PrimaryHovered: {
    value: "rgba(0, 185, 208, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅍㄹㅇㅁㄹㅎㅂ / Primary 색상의 \bHovered 상태입니다."
  },
  PrimaryPressed: {
    value: "rgba(0, 180, 203, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅍㄹㅇㅁㄹㅍㄹㅅ / Primary 색상의 Pressed 상태입니다."
  },
  PrimarySubtle: {
    value: "rgba(232, 246, 248, 1)",
    type: "color"
  },
  PrimarySubtleHovered: {
    value: "rgba(224, 242, 245, 1)",
    type: "color"
  },
  PrimarySubtlePressed: {
    value: "rgba(213, 237, 240, 1)",
    type: "color"
  },
  Secondary: {
    value: "rgba(240, 240, 240, 1)",
    type: "color",
    description: "구)B06 / ㅂㅌㅇ.ㅅㅋㄷㄹ / Secondary 색상의 Enabled 상태입니다."
  },
  SecondaryHovered: {
    value: "rgba(235, 235, 235, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅅㅋㄷㄹㅎㅂ / Secondary 색상의 Hovered 상태입니다."
  },
  SecondaryPressed: {
    value: "rgba(230, 230, 230, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅅㅋㄷㄹㅍㄹㅅ / Secondary 색상의 Pressed 상태입니다."
  },
  SecondarySubtle: {
    value: "rgba(247, 247, 247, 1)",
    type: "color"
  },
  SecondarySubtleHovered: {
    value: "rgba(245, 245, 245, 1)",
    type: "color"
  },
  SecondarySubtlePressed: {
    value: "rgba(242, 242, 242, 1)",
    type: "color"
  },
  LinedSecondary: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㄹㅇㄷㅅㅋㄷㄹ / Outlined Secondary 스타일 버튼의 Enabled 상태에 배경색으로 사용합니다."
  },
  LinedSecondaryHovered: {
    value: "rgba(253, 253, 253, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㄹㅇㄷㅅㅋㄷㄹㅎㅂ / Outlined Secondary 스타일 버튼의 Hovered 상태에 배경색으로 사용합니다."
  },
  LinedSecondaryPressed: {
    value: "rgba(252, 252, 252, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㄹㅇㄷㅅㅋㄷㄹㅍㄹㅅ / Outlined Secondary 스타일 버튼의 Pressed 상태에 배경색으로 사용합니다."
  },
  Tertiary: {
    value: "rgba(66, 75, 76, 1)",
    type: "color",
    description: "구)DarkGR / ㅂㅌㅇ.ㅌㅌㅇㄹ / Tertiary 색상의 Enabled 상태입니다. Inverse의 성격을 띄고 있습니다."
  },
  TertiaryHovered: {
    value: "rgba(62, 71, 72, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅌㅌㅇㄹㅎㅂ / Tertiary 색상의 Hovered 상태입니다."
  },
  TertiaryPressed: {
    value: "rgba(59, 68, 69, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅌㅌㅇㄹㅍㄹㅅ / Tertiary 색상의 Pressed 상태입니다."
  },
  Quaternary: {
    value: "rgba(26, 124, 136, 1)",
    type: "color",
    description: "구)DeepBU / ㅂㅌㅇ.ㅋㅌㄴㄹ / Quaternary 색상의 Enabled 상태입니다."
  },
  QuaternaryHovered: {
    value: "rgba(28, 117, 129, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅋㅌㄴㄹㅎㅂ / Quaternary 색상의 Hovered 상태입니다."
  },
  QuaternaryPressed: {
    value: "rgba(31, 111, 122, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅋㅌㄴㄹㅍㄹㅅ / Quaternary 색상의 Pressed 상태입니다."
  },
  Warning: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅂㅌㅇ.ㅇㄴ / Warning 컬러의 Enabled 상태입니다."
  },
  WarningHovered: {
    value: "rgba(244, 78, 78, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅇㄴㅎㅂ / Warning 컬러의 Hovered 상태입니다."
  },
  WarningPressed: {
    value: "rgba(232, 74, 74, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㅇㄴㅍㄹㅅ / Warning 컬러의 Pressed 상태입니다."
  },
  LinedWarning: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W100 / ㅂㅌㅇ.ㄹㅇㄷㅇㄴ"
  },
  LinedWarningHovered: {
    value: "rgba(255, 251, 251, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㄹㅇㄷㅇㄴㅎㅂ / Outlined Warning 스타일 버튼의 Hovered 상태에 배경색으로 사용합니다."
  },
  LinedWarningPressed: {
    value: "rgba(255, 247, 247, 1)",
    type: "color",
    description: "ㅂㅌㅇ.ㄹㅇㄷㅇㄴㅍㄹㅅ / Outlined Warning 스타일 버튼의 Pressed 상태에 배경색으로 사용합니다."
  },
  OnTint: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W100 / ㅂㅌㅇ.ㅇㅌㅌ / Tint 배경색 위에 올라가는 버튼에 사용합니다. Enabled 상태입니다."
  },
  OnTintHovered: {
    value: "rgba(255, 255, 255, 0.95)",
    type: "color",
    description: "ㅂㅌㅇ.ㅇㅌㅌㅎㅂ / Tint 배경색 위에 올라가는 버튼에 사용합니다. Hovered 상태입니다."
  },
  OnTintPressed: {
    value: "rgba(255, 255, 255, 0.9)",
    type: "color",
    description: "ㅂㅌㅇ.ㅇㅌㅌㅍㄹㅅㄷ / Tint 배경색 위에 올라가는 버튼에 사용합니다. Pressed 상태입니다."
  },
  LinedOnTint: {
    value: "rgba(255, 255, 255, 0.0)",
    type: "color"
  },
  LinedOnTintHovered: {
    value: "rgba(255, 255, 255, 0.05)",
    type: "color"
  },
  LinedOnTintPressed: {
    value: "rgba(255, 255, 255, 0.1)",
    type: "color"
  },
  OnTintSubdued: {
    value: "rgba(255, 255, 255, 0.4)",
    type: "color"
  },
  OnTintSubduedHovered: {
    value: "rgba(255, 255, 255, 0.35)",
    type: "color"
  },
  OnTintSubduedPressed: {
    value: "rgba(255, 255, 255, 0.3)",
    type: "color"
  },
  Border: {
    value: "rgba(0, 0, 0, 0.1)",
    type: "color",
    description: "버튼 중 진한 보더색상에 사용합니다."
  },
  BorderHovered: {
    value: "rgba(0, 0, 0, 0.13)",
    type: "color",
    description: "버튼 중 진한 보더색상에 사용합니다."
  },
  BorderPressed: {
    value: "rgba(0, 0, 0, 0.15)",
    type: "color",
    description: "버튼 중 진한 보더색상에 사용합니다."
  },
  Clear: {
    value: "rgba(0, 0, 0, 0)",
    type: "color"
  },
  ClearHovered: {
    value: "rgba(0, 0, 0, 0.01)",
    type: "color",
    description: "클리어에 호버가 되었을 때 나타나는 색상입니다."
  },
  ClearPressed: {
    value: "rgba(0, 0, 0, 0.02)",
    type: "color",
    description: "클리어에 \b프레스가 되었을 때 나타나는 색상입니다."
  },
  Disabled: {
    value: "rgba(0, 0, 0, 0.05)",
    type: "color",
    description: "ㅂㅌㅇ.ㄷㅅㅇㅇㅂㄷ / 버튼이 Disabled인 경우 배경색으로 사용합니다."
  },
  DisabledSubdued: {
    value: "rgba(0, 0, 0, 0.1)",
    type: "color",
    description: "ㅂㅌㅇ.ㄷㅅㅇㅇㅂㄷㅅㄷㄷ / BTN.Disabled를 사용해도 약하게 느껴질 경우 사용합니다. BTN.Disabled를 우선 사용합니다."
  }
}, Be = {
  Primary: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W / ㅂㅈ.ㅍㄹㅇㅁㄹ / 레벨0의 가장 낮은부분에 들어가는 색상입니다."
  },
  Secondary: {
    value: "rgba(242, 242, 242, 1)",
    type: "color",
    description: "구)B05 / ㅂㅈ.ㅅㅋㄷㄹ/ 레벨0의 가장 낮은부분에 들어가는 색상입니다. 레벨 1 이상의 뷰에서 카드뷰 또는 섹션뷰가 쓰일 경우 해당 색상을 사용합니다."
  }
}, He = {
  Primary: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W / ㅅㅍㅇㅅ.ㅍㄹㅇㅁㄹ / 레벨1 이상의 모든 백그라운드 색상에 사용됩니다."
  },
  Secondary: {
    value: "rgba(247, 247, 247, 1)",
    type: "color",
    description: "구)B03 / ㅅㅍㅇㅅ.ㅅㅋㄷㄹ / 박스형태의 배경색으로 자주 쓰입니다."
  },
  Tertiary: {
    value: "rgba(66, 75, 76, 1)",
    type: "color",
    description: "구)DarkGR / ㅅㅍㅇㅅ.ㅌㅌㅇㄹ / 레이어에 대비차를 이용하여 강조할 때 사용합니다. 예를 들어 툴팁 배경색으로도 사용됩니다."
  },
  Divider: {
    value: "rgba(0, 0, 0, 0.06)",
    type: "color",
    description: "구)B06 / ㅅㅍㅇㅅ.ㄷㅂㅇㄷ / 디바이더에 사용합니다."
  },
  Clear: {
    value: "rgba(0, 0, 0, 0)",
    type: "color",
    description: "ㅅㅍㅇㅅ ㅋㄹㅇ / 배경에 아무런 색상이 없을 경우 사용합니다."
  },
  Border: {
    value: "rgba(0, 0, 0, 0.1)",
    type: "color",
    description: "구)B10 / ㅅㅍㅇㅅ.ㅂㄷ / 주로 선 색상에 사욯합니다."
  },
  Disabled: {
    value: "rgba(242, 242, 242, 1)",
    type: "color",
    description: "구)B05 / ㅅㅍㅇㅅ.ㄷㅅㅇㅇㅂㄷ / 디스에이블이 된 경우 사용합니다. 예를들어 매니저의 업무카드가 Disabled 상태인 경우 카드의 배경색으로 사용합니다."
  },
  DimBG: {
    value: "rgba(0, 0, 0, 0.3)",
    type: "color",
    description: "ㅅㅍㅇㅅ.ㄷㅂㅈ / 모달이 뜨는 경우 배경의 색상을 딤처리할 때 사용합니다."
  },
  Inverse: {
    value: "rgba(0, 0, 0, 0.9)",
    type: "color",
    description: "ㅅㅍㅇㅅ.ㅇㅂㅅ/ 배경색과 대비차를 강하게 하여 주목도를 높이기 위해 사용합니다. 예를 들어 스낵바(토스트)의 배경색상으로 사용됩니다."
  },
  AccentPrimary: {
    value: "rgba(0, 190, 214, 1)",
    type: "color",
    description: "구)BU / ㅅㅍㅇㅅ.ㅇㅅㅌㅍㄹㅇㅁㄹ / 배경색상으로 브랜드 색상 또는 강조해야하는 경우 가장 우선순위가 높은 색상입니다. 예를 들어 고객앱의 내 예약 상세 또는 매니저앱의 스케쥴 상세에서 사용됩니다."
  },
  AccentSubdued: {
    value: "rgba(26, 124, 136, 1)",
    type: "color",
    description: "구)DeepBU / ㅅㅍㅇㅅ.ㅇㅅㅌㅅㄷㄷ / Accent 색상이 대비차가 강한 경우 사용합니다. 예를 들어 채팅의 버블 중 청연톡에 사용합니다."
  },
  AccentSubtle: {
    value: "rgba(232, 246, 248, 1)",
    type: "color",
    description: "구)LBU / ㅅㅍㅇㅅ.ㅇㅅㅌㅅㅌ / 일반적인 박스보다 좀 더 하이라이트를 주고 싶을 때 사용합니다."
  },
  AccentDisabled: {
    value: "rgba(156, 169, 171, 1)",
    type: "color",
    description: "구)DimBU / ㅅㅍㅇㅅ.ㅇㅅㅌㄷㅅㅇㅇㅂㄷ / ACCENT의 Disabled 상태에 사용합니다. 예를 들어 매니저앱의 스케쥴상세에서 업무가 취소된 경우 배경색으로 사용됩니다."
  },
  AccentSecondary: {
    value: "rgba(0, 75, 130, 1)",
    type: "color",
    description: "구)DarkBU / ㅅㅍㅇㅅ.ㅇㅅㅌㅅㅋㄷㄹ / 배경색상으로 브랜드 색상 또는 강조해야하는 경우 쓰입니다. 주색은 아니므로 청연블루 색상을 먼저 사용해보고 무드에 안맞을 경우 사용하세요."
  },
  Important: {
    value: "rgba(255, 107, 107, 1)",
    type: "color",
    description: "구)W01 / ㅅㅍㅇㅅ.ㅇㅍㅌㅌ / 뱃지에 Accent보다 더 강조하고 싶을 때 사용합니다. Accent나 AccentSubdued를 먼저 사용하였을 경우 써주세요."
  },
  ImportantSubtle: {
    value: "rgba(255, 235, 235, 1)",
    type: "color",
    description: "구)LR / ㅅㅍㅇㅅ.ㅇㅍㅌㅌㅅㅌ / 웜계열의 부드러운 색상을 사용하고 싶을경우 사용합니다."
  },
  Warning: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅅㅍㅇㅅ.ㅇㄴ / 경고의 의미로 사용합니다. 주로 뱃지같은 작은 영역에 사용됩니다."
  },
  Unread: {
    value: "rgba(255, 251, 239, 1)",
    type: "color",
    description: "구)LY / ㅅㅍㅇㅅ.ㅇㄹㄷ / 읽지 않은 카드 또는 섹션에 사용하는 색상입니다."
  }
}, Te = {
  ActiveAccent: {
    value: "rgba(0, 190, 214, 1)",
    type: "color",
    description: "구)BU / ㅇㄷㅋㅇㅌ.ㅇㅌㅌㅇㅅㅌ / Active상태의 강조하고 싶은곳에 사용합니다."
  },
  ActiveAccentSubtle: {
    value: "rgba(232, 246, 248, 1)",
    type: "color",
    description: "구)LBU / ㅇㄷㅋㅇㅌ.ㅇㅌㅂㅇㅅㅌㅅㅌ / Active상태의 BG색상으로 사용합니다. Primary와 Secondary를 우선 사용해 주세요."
  },
  ActivePrimary: {
    value: "rgba(66, 75, 76, 1)",
    type: "color",
    description: "구)DarkGR / ㅇㄷㅋㅇㅌ.ㅇㅌㅂㅍㄹㅇㅁㄹ / Active상태의 BG색상으로 사용합니다."
  },
  ActiveSecondary: {
    value: "rgba(38, 38, 38, 1)",
    type: "color",
    description: "구)B85 / ㅇㄷㅋㅇㅌ.ㅇㅌㅂㅅㅋㄷㄹ / Active상태의 BG색상으로 사용합니다. Primary를 우선 사용해 주세요."
  },
  ActiveSecondarySubdued: {
    value: "rgba(0, 0, 0, 0.6)",
    type: "color",
    description: "구)B06 / ㅇㄷㅋㅇㅌ.ㅇㅌㅂㅅㅋㄷㄹㅅㄷㄷ / ActiveSecondary의 약한 색상으로 사용합니다."
  },
  Warning: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅇㄷㅋㅇㅌ.ㅇㄴ / Active상태의 워닝색상으로 사용합니다."
  },
  ActiveDisabled: {
    value: "rgba(156, 169, 171, 1)",
    type: "color",
    description: "구)DimBU / ㅇㄷㅋㅇㅌ.ㅇㅌㅂㄷㅅㅇㅇㅂㄷ / Active상태의 디스에이블에 사용합니다."
  },
  ActiveOnTint: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W100 / ㅇㄷㅋㅇㅌ.ㅇㅌㅂㅇㅌㅌ / 배경색이 명도가 짙은 경우 Active상태의 BG색상으로 사용합니다."
  },
  InactivePrimary: {
    value: "rgba(247, 247, 247, 1)",
    type: "color",
    description: "구)B03 / ㅇㄷㅋㅇㅌ.ㅇㅇㅌㅂㅍㄹㅇㅁㄹ / Inactive상태의 배경색으로 사용됩니다."
  },
  InactiveSecondary: {
    value: "rgba(0, 0, 0, 0.06)",
    type: "color",
    description: "구)B06 / ㅇㄷㅋㅇㅌ.ㅇㅇㅌㅂㅅㅋㄷㄹ / Inactive상태이며, 닷인디케이터, 프로그레스바에서 사용됩니다."
  },
  InactiveTertiary: {
    value: "rgba(0, 0, 0, 0.1)",
    type: "color",
    description: "구)B10 ㅇㄷㅋㅇㅌ.ㅇㅇㅌㅂㅌㅌㅇㄹ / Inactive상태에 사용합니다. 주로 선에 사용됩니다."
  },
  InactiveOnTint: {
    value: "rgba(255, 255, 255, 0.4)",
    type: "color",
    description: "구)W40 / ㅇㄷㅋㅇㅌ.ㅇㅇㅌㅂㅇㅌㅌ / 배경의 명도가 짙은 경우 Inactive상태에 사용됩니다."
  },
  InactiveQuaternary: {
    value: "rgba(204, 204, 204, 1)",
    type: "color",
    description: "구)B20 / ㅇㄷㅋㅇㅌ.ㅇㅇㅌㅂㅋㅌㄴㄹ / 체크박스, 라디오박스 등의 Inactive 상태에서 사용합니다."
  },
  SelectorBG: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    description: "구)W100 / ㅇㄷㅋㅇㅌ.ㅅㄹㅌㅂㅈ /  체크박스나 라디오버튼의 배경 색상으로 사용합니다."
  },
  InactiveDisabled: {
    value: "rgba(242, 242, 242, 1)",
    type: "color",
    description: "구)B05 / ㅇㄷㅋㅇㅌ.ㅇㅇㅌㅂㄷㅅㅇㅇㅂㄷ / 디스에이블이 된 경우 사용합니다. 예를들어 체크박스가 Disabled인 경우 해당 색상을 사용합니다."
  }
}, _e = {
  BG: {
    value: "rgba(247, 247, 247, 1)",
    type: "color",
    description: "구)B03 / ㅍㄷ.ㅂㅈ / Filled Text Field의 배경색으로 쓰입니다."
  },
  DisabledBG: {
    value: "rgba(241, 243, 243, 1)",
    type: "color",
    description: "Coolgrey 10 / ㅍㄷ ㄷㅅㅇㅇㅂㄷ ㅂㅈ / 필드배경 중 디스에이블 성격을 가지고 있을 경우 사용됩니다."
  },
  Lined: {
    value: "rgba(204, 204, 204, 1)",
    type: "color",
    description: "구)B20 / ㅍㄷ.ㄹㅇㄷ / Field의 Rested 또는 Enabled 상태에 사용합니다."
  },
  Active: {
    value: "rgba(0, 190, 214, 1)",
    type: "color",
    description: "구)BU / ㅍㄷ.ㅇㅌㅂ / Field의 Activate와 커서에 사용됩니다."
  },
  Error: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅍㄷ.ㅇㄹ / Field의 Error 상태에 사용합니다."
  },
  LinedDisabled: {
    value: "rgba(242, 242, 242, 1)",
    type: "color",
    description: "구)B05 / ㅍㄷ.ㄹㅇㄷㄷㅅㅇㅇㅂㄷ / Disabled의 Bottom Border에 사용합니다."
  }
}, me = {
  HouseWork: {
    value: "rgba(66, 151, 212, 1)",
    type: "color",
    description: "구)C03 / ㅌㄱ.ㅌㄱ / 매니저앱에서만 사용됩니다. 가정청소를 구분하기 위한 색상입니다."
  },
  OfficeWork: {
    value: "rgba(243, 114, 184, 1)",
    type: "color",
    description: "구)W02 / ㅌㄱ.ㅇㅍㅅㅇㅋ / 매니저앱에서만 사용됩니다. 사무실 청소에서만 사용되는 색상입니다."
  },
  Peak: {
    value: "rgba(243, 114, 184, 1)",
    type: "color",
    description: "성수기, 비싼날의 의미입니다."
  },
  StoreSale: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅌㄱ.ㅅㅌㅇㅅㅇ / 스토어 제품의 세일에서만 사용되는 색상입니다."
  },
  BookingHoliday: {
    value: "rgba(249, 83, 83, 1)",
    type: "color",
    description: "구)R / ㅌㄱ.ㅂㅋㅎㄹㄷㅇ / 달력에서 공휴일에만 사용합니다."
  },
  ReviewBadge: {
    value: "rgba(255, 191, 0, 1)",
    type: "color",
    description: "ㅌㄱ.ㄹㅂㅂㅈ / 리뷰뱃지에 사용되는 노란색입니다."
  },
  BalanceInactive: {
    value: "rgba(174, 233, 241, 1)",
    type: "color",
    description: "ㅌㄱ.ㅂㄹㅅㅇㅇㅌㅂ / 매니저 정산내역에서 챠트 바의 인엑티브 영역에 사용합니다."
  },
  BadgeText: {
    value: "rgba(0, 75, 130, 1)",
    type: "color"
  }
}, r = {
  Text: Se,
  BTN: Pe,
  BG: Be,
  Surface: He,
  Indicator: Te,
  Field: _e,
  Tag: me
}, Wn = r, De = {
  B1_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ1 ㅇ"
  },
  B1_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ1 ㅇㅅㅂ"
  },
  B1_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ1 ㅂ"
  },
  B2_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ2 ㅇ"
  },
  B2_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ2 ㅇㅅㅂ"
  },
  B2_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ2 ㅂ"
  },
  B3_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ3 ㅇ"
  },
  B3_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ3 ㅇㅅㅂ"
  },
  B3_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ3 ㅂ"
  },
  B4_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ4 ㅇ"
  },
  B4_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ4 ㅇㅅㅂ"
  },
  B4_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ4 ㅂ"
  },
  B1_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ1 ㅇ ㅇㅅㅅ"
  },
  B1_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ1 ㅇㅅㅂ ㅇㅅㅅ"
  },
  B1_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ1 ㅂ ㅇㅅㅅ"
  },
  B2_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ2 ㅇ ㅇㅅㅅ"
  },
  B2_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ2 ㅇㅅㅂ ㅇㅅㅅ"
  },
  B2_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ2 ㅂ ㅇㅅㅅ"
  },
  B3_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ3 ㅇ ㅇㅅㅅ"
  },
  B3_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ3 ㅇㅅㅂ ㅇㅅㅅ"
  },
  B3_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ3 ㅂ ㅇㅅㅅ"
  },
  B4_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ4 ㅇ ㅇㅅㅅ"
  },
  B4_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ4 ㅇㅅㅂ ㅇㅅㅅ"
  },
  B4_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㅂㄷ ㅂ4 ㅂ ㅇㅅㅅ"
  }
}, Ce = {
  T1_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "21px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ1 ㅇ"
  },
  T1_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "21px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ1 ㅇㅅㅂ"
  },
  T1_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "21px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ1 ㅂ"
  },
  T2_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "19px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ2 ㅇ"
  },
  T2_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "19px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ2 ㅇㅅㅂ"
  },
  T2_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "19px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ2 ㅂ"
  },
  T3_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ3 ㅇ"
  },
  T3_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ3 ㅇㅅㅂ"
  },
  T3_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㅌㅇㅌ ㅌ3 ㅂ"
  }
}, Ae = {
  HD1_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "33px"
    },
    type: "typography",
    description: `ㅎㄷ ㅎㄷ1 ㅂ

매니저 정산내역 금액 타이틀로 표시 중`
  },
  HD2_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "30px"
    },
    type: "typography",
    description: `ㅎㄷ ㅎㄷ2 ㅂ
1. 매니저 인증번호 입력 폼`
  },
  HD3_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "27px"
    },
    type: "typography",
    description: "ㅎㄷ ㅎㄷ3 ㅂ"
  },
  HD4_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "25px"
    },
    type: "typography",
    description: `ㅎㄷ ㅎㄷ4 ㅇㅅㅂ
1. 네비바(툴바) 아래 라지타이틀
2. 매니저 업무카드 상세에서 요일표시
3. 고객카드에서 날짜표시
4. 스토어 가격`
  },
  HD4_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "25px"
    },
    type: "typography",
    description: "ㅎㄷ ㅎㄷ4 ㅂ"
  },
  HD5_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "23px"
    },
    type: "typography",
    description: `ㅎㄷ ㅎㄷ5 ㅂ
서브타이틀로 쓰이는 너낌

1. 고객 > 예약 > 날짜 선택 시
2. 매니저 > 업무카드 수락 시 뜨는 팝업 제목
3. 모달 알럿창 제목
4. 매니저 > 업무카드 내 날짜(요일) 시간`
  }
}, Ee = {
  DP_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "42px"
    },
    type: "typography",
    description: `ㄷㅅㅍㄹㅇ ㄷㅍ ㅇ
1. 포인트 타이틀`
  },
  DP_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "42px"
    },
    type: "typography",
    description: `ㄷㅅㅍㄹㅇ ㄷㅍ ㅂ
1. 평수 입력 시
2. 포인트 타이틀`
  }
}, we = {
  Label1_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ1 ㅇ"
  },
  Label1_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ1 ㅇㅅㅂ"
  },
  Label1_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ1 ㅂ"
  },
  Label2_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ2 ㅇ"
  },
  Label2_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ2 ㅇㅅㅂ"
  },
  Label2_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ2 ㅂ"
  },
  Label3_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ3 ㅇ"
  },
  Label3_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ3 ㅇㅅㅂ"
  },
  Label3_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ3 ㅂ"
  },
  Label4_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ4 ㅇ"
  },
  Label4_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ4 ㅇㅅㅂ"
  },
  Label4_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ4 ㅂ"
  },
  Label5_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "12px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅇ"
  },
  Label5_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "12px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅇㅅㅂ"
  },
  Label5_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "12px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅂ"
  },
  Label6_R: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "10px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ6 ㅇ"
  },
  Label6_SB: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "10px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ6 ㅇㅅㅂ"
  },
  Label6_B: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "10px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ6 ㅂ"
  },
  Label1_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ1 ㅇ ㅇㅅㅅ"
  },
  Label1_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ1 ㅇㅅㅂ ㅇㅅㅅ"
  },
  Label1_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "17px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ1 ㅂ ㅇㅅㅅ"
  },
  Label2_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ2 ㅇ ㅇㅅㅅ"
  },
  Label2_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ2 ㅇㅅㅂ ㅇㅅㅅ"
  },
  Label2_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "16px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ2 ㅂ ㅇㅅㅅ"
  },
  Label3_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ3 ㅇ ㅇㅅㅅ"
  },
  Label3_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ3 ㅇㅅㅂ ㅇㅅㅅ"
  },
  Label3_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ3 ㅂ ㅇㅅㅅ"
  },
  Label4_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "15px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ4 ㅇ ㅇㅅㅅ"
  },
  Label4_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅇㅅㅂ ㅇㅅㅅ"
  },
  Label4_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "14px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ4 ㅂ ㅇㅅㅅ"
  },
  Label5_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "12px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅇ ㅇㅅㅅ"
  },
  Label5_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "12px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅇㅅㅂ ㅇㅅㅅ"
  },
  Label5_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "12px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ5 ㅂ ㅇㅅㅅ"
  },
  Label6_R_A11Y: {
    value: {
      "font-weight": "400",
      "line-height": "140%",
      "font-size": "10px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ6 ㅇ ㅇㅅㅅ"
  },
  Label6_SB_A11Y: {
    value: {
      "font-weight": "600",
      "line-height": "140%",
      "font-size": "10px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ6 ㅇㅅㅂ ㅇㅅㅅ"
  },
  Label6_B_A11Y: {
    value: {
      "font-weight": "700",
      "line-height": "140%",
      "font-size": "10px"
    },
    type: "typography",
    description: "ㄹㅇㅂ ㄹㅇㅂ6 ㅂ ㅇㅅㅅ"
  }
}, P = {
  Body: De,
  Title: Ce,
  Heading: Ae,
  Display: Ee,
  Label: we
}, ze = (e) => {
  var n, i;
  const [a, t] = e.split("/");
  return (i = (n = P == null ? void 0 : P[a]) == null ? void 0 : n[t]) == null ? void 0 : i.value;
}, x = (e) => {
  var n, i;
  if (!e) return e;
  const [a, t] = e.split("/");
  return ((i = (n = r == null ? void 0 : r[a]) == null ? void 0 : n[t]) == null ? void 0 : i.value) || e;
};
Object.keys(r).reduce(
  (e, a) => [
    ...e,
    ...Object.keys(r[a]).map((t) => `${a}/${t}`)
  ],
  []
);
const Le = {
  Primary: "rgba(38, 38, 38, 1)",
  PrimaryHovered: "rgba(38, 38, 38, 0.9)",
  PrimaryPressed: "rgba(38, 38, 38, 0.8)",
  Secondary: "rgba(102, 102, 102, 1)",
  Tertiary: "rgba(66, 75, 76, 1)",
  TertiaryHovered: "rgba(66, 75, 76, 0.9)",
  TertiaryPressed: "rgba(66, 75, 76, 0.8)",
  Support: "rgba(153, 153, 153, 1)",
  SupportHovered: "rgba(153, 153, 153, 0.9)",
  SupportPressed: "rgba(153, 153, 153, 0.8)",
  Inactive: "rgba(153, 153, 153, 1)",
  SupportIcon: "rgba(204, 204, 204, 1)",
  SupportIconHovered: "rgba(204, 204, 204, 0.9)",
  SupportIconPressed: "rgba(204, 204, 204, 0.8)",
  Disabled: "rgba(0, 0, 0, 0.2)",
  DisabledOntint: "rgba(255, 255, 255, 0.2)",
  DisabledAccent: "rgba(0, 190, 214, 0.4)",
  DisabledSubtle: "rgba(0, 0, 0, 0.1)",
  AccentDisabled: "rgba(118, 130, 131, 1)",
  OnTint: "rgba(255, 255, 255, 1)",
  OnTintHovered: "rgba(255, 255, 255, 0.9)",
  OnTintPressed: "rgba(255, 255, 255, 0.8)",
  OnTintSubdued: "rgba(255, 255, 255, 0.6)",
  Accent: "rgba(0, 190, 214, 1)",
  AccentHovered: "rgba(0, 185, 208, 1)",
  AccentPressed: "rgba(0, 180, 203, 1)",
  AccentSubdued: "rgba(26, 124, 136, 1)",
  AccentSubduedHovered: "rgba(26, 124, 136, 0.9)",
  AccentSubduedPressed: "rgba(26, 124, 136, 0.8)",
  Inverse: "rgba(255, 255, 255, 1)",
  InverseHovered: "rgba(255, 255, 255, 0.9)",
  InversePressed: "rgba(255, 255, 255, 0.8)",
  InverseSubdued: "rgba(255, 255, 255, 0.6)",
  InverseAccent: "rgba(9, 158, 177, 1)",
  Warning: "rgba(249, 83, 83, 1)",
  WarningHovered: "rgba(249, 83, 83, 0.9)",
  WarningPressed: "rgba(249, 83, 83, 0.8)",
  Error: "rgba(249, 83, 83, 1)",
  PrimaryOntint: "rgba(38, 38, 38, 1)",
  PrimaryOntintHovered: "rgba(38, 38, 38, 0.9)",
  PrimaryOntintPressed: "rgba(38, 38, 38, 0.8)"
}, $e = {
  Primary: "rgba(0, 190, 214, 1)",
  PrimaryHovered: "rgba(0, 185, 208, 1)",
  PrimaryPressed: "rgba(0, 180, 203, 1)",
  LinedPrimary: "rgba(0, 190, 214, 0)",
  LinedPrimaryHovered: "rgba(0, 190, 214, 0.02)",
  LinedPrimaryPressed: "rgba(0, 190, 214, 0.03)",
  PrimarySubtle: "rgba(232, 246, 248, 1)",
  PrimarySubtleHovered: "rgba(224, 242, 245, 1)",
  PrimarySubtlePressed: "rgba(213, 237, 240, 1)",
  Secondary: "rgba(240, 240, 240, 1)",
  SecondaryHovered: "rgba(235, 235, 235, 1)",
  SecondaryPressed: "rgba(230, 230, 230, 1)",
  SecondarySubtle: "rgba(247, 247, 247, 1)",
  SecondarySubtleHovered: "rgba(245, 245, 245, 1)",
  SecondarySubtlePressed: "rgba(242, 242, 242, 1)",
  LinedSecondary: "rgba(0, 0, 0, 0)",
  LinedSecondaryHovered: "rgba(0, 0, 0, 0.01)",
  LinedSecondaryPressed: "rgba(0, 0, 0, 0.02)",
  Tertiary: "rgba(66, 75, 76, 1)",
  TertiaryHovered: "rgba(62, 71, 72, 1)",
  TertiaryPressed: "rgba(59, 68, 69, 1)",
  PrimarySubdued: "rgba(26, 124, 136, 1)",
  PrimarySubduedHovered: "rgba(28, 117, 129, 1)",
  PrimarySubduedPressed: "rgba(31, 111, 122, 1)",
  Warning: "rgba(249, 83, 83, 1)",
  WarningHovered: "rgba(244, 78, 78, 1)",
  WarningPressed: "rgba(232, 74, 74, 1)",
  LinedWarning: "rgba(249, 83, 83, 0)",
  LinedWarningHovered: "rgba(249, 83, 83, 0.01)",
  LinedWarningPressed: "rgba(249, 83, 83, 0.02)",
  Error: "rgba(249, 83, 83, 1)",
  ErrorHovered: "rgba(244, 78, 78, 1)",
  ErrorPressed: "rgba(232, 74, 74, 1)",
  OnTint: "rgba(255, 255, 255, 1)",
  OnTintHovered: "rgba(255, 255, 255, 0.95)",
  OnTintPressed: "rgba(255, 255, 255, 0.9)",
  Inverse: "rgba(255, 255, 255, 1)",
  InverseHovered: "rgba(247, 247, 247, 1)",
  InversePressed: "rgba(240, 240, 240, 1)",
  LinedOnTint: "rgba(255, 255, 255, 0.0)",
  LinedOnTintHovered: "rgba(255, 255, 255, 0.05)",
  LinedOnTintPressed: "rgba(255, 255, 255, 0.1)",
  OnTintSubdued: "rgba(255, 255, 255, 0.4)",
  OnTintSubduedHovered: "rgba(255, 255, 255, 0.35)",
  OnTintSubduedPressed: "rgba(255, 255, 255, 0.3)",
  BorderSubtle: "rgba(0, 0, 0, 0.06)",
  BorderSubtleHovered: "rgba(0, 0, 0, 0.09)",
  BorderSubtlePressed: "rgba(0, 0, 0, 0.12)",
  Border: "rgba(0, 0, 0, 0.1)",
  BorderHovered: "rgba(0, 0, 0, 0.13)",
  BorderPressed: "rgba(0, 0, 0, 0.15)",
  BorderSubdued: "rgba(0, 0, 0, 0.2)",
  BorderSubduedHovered: "rgba(0, 0, 0, 0.23)",
  BorderSubduedPressed: "rgba(0, 0, 0, 0.25)",
  Clear: "rgba(0, 0, 0, 0)",
  ClearHovered: "rgba(0, 0, 0, 0.01)",
  ClearPressed: "rgba(0, 0, 0, 0.02)",
  Disabled: "rgba(0, 0, 0, 0.05)",
  DisabledSubdued: "rgba(0, 0, 0, 0.1)",
  DisabledOntint: "rgba(255, 255, 255, 0.2)",
  DisabledAccent: "rgba(156, 169, 171, 1)"
}, Ie = {
  Primary: "rgba(255, 255, 255, 1)",
  Secondary: "rgba(242, 242, 242, 1)"
}, We = {
  Primary: "rgba(255, 255, 255, 1)",
  Secondary: "rgba(247, 247, 247, 1)",
  Tertiary: "rgba(66, 75, 76, 1)",
  Divider: "rgba(0, 0, 0, 0.06)",
  Clear: "rgba(0, 0, 0, 0)",
  Border: "rgba(0, 0, 0, 0.1)",
  Disabled: "rgba(242, 242, 242, 1)",
  DimBG: "rgba(0, 0, 0, 0.3)",
  Inverse: "rgba(0, 0, 0, 0.9)",
  AccentPrimary: "rgba(0, 190, 214, 1)",
  AccentSubdued: "rgba(26, 124, 136, 1)",
  AccentSubtle: "rgba(232, 246, 248, 1)",
  AccentDisabled: "rgba(156, 169, 171, 1)",
  AccentSecondary: "rgba(0, 75, 130, 1)",
  Important: "rgba(255, 107, 107, 1)",
  ImportantSubtle: "rgba(255, 235, 235, 1)",
  Warning: "rgba(249, 83, 83, 1)",
  Unread: "rgba(255, 251, 239, 1)"
}, Re = {
  focusDim: "rgba(0, 0, 0, 0.6)",
  HouseWork: "rgba(66, 151, 212, 1)",
  OfficeWork: "rgba(243, 114, 184, 1)",
  Peak: "rgba(243, 114, 184, 1)",
  StoreSale: "rgba(249, 83, 83, 1)",
  BookingHoliday: "rgba(249, 83, 83, 1)",
  ReviewBadge: "rgba(255, 191, 0, 1)",
  BalanceInactive: "rgba(174, 233, 241, 1)",
  BadgeText: "rgba(0, 75, 130, 1)"
}, Oe = {
  ActiveAccent: "rgba(0, 190, 214, 1)",
  ActiveAccentSubtle: "rgba(232, 246, 248, 1)",
  ActivePrimary: "rgba(66, 75, 76, 1)",
  ActiveSecondary: "rgba(38, 38, 38, 1)",
  ActiveSecondarySubdued: "rgba(0, 0, 0, 0.6)",
  Warning: "rgba(249, 83, 83, 1)",
  WarningDisabled: "rgba(255, 162, 162, 1)",
  ActiveDisabled: "rgba(156, 169, 171, 1)",
  ActiveOnTint: "rgba(255, 255, 255, 1)",
  InactivePrimary: "rgba(247, 247, 247, 1)",
  InactiveSecondary: "rgba(0, 0, 0, 0.06)",
  InactiveTertiary: "rgba(0, 0, 0, 0.1)",
  InactiveOnTint: "rgba(255, 255, 255, 0.4)",
  InactiveQuaternary: "rgba(204, 204, 204, 1)",
  ActiveAccentDisabled: "rgba(116, 220, 233, 1)",
  InactiveDisabled: "rgba(0, 0, 0, 0.05)",
  SelectorBG: "rgba(255, 255, 255, 1)",
  SelectoFG: "rgba(255, 255, 255, 1)"
}, Ne = {
  BG: "rgba(247, 247, 247, 1)",
  DisabledBG: "rgba(241, 243, 243, 1)",
  Lined: "rgba(204, 204, 204, 1)",
  Active: "rgba(0, 190, 214, 1)",
  Error: "rgba(249, 83, 83, 1)",
  LinedDisabled: "rgba(242, 242, 242, 1)"
}, $ = {
  Text: Le,
  BTN: $e,
  BG: Ie,
  Surface: We,
  Tag: Re,
  Indicator: Oe,
  Field: Ne
}, ke = {
  bgPrimary: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgSecondary: {
    Enabled: "rgba(240, 240, 240, 1)",
    Hovered: "rgba(235, 235, 235, 1)",
    Pressed: "rgba(230, 230, 230, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgSecondarySubtle: {
    Enabled: "rgba(247, 247, 247, 1)",
    Hovered: "rgba(245, 245, 245, 1)",
    Pressed: "rgba(242, 242, 242, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgTertiary: {
    Enabled: "rgba(66, 75, 76, 1)",
    Hovered: "rgba(62, 71, 72, 1)",
    Pressed: "rgba(59, 68, 69, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgWarning: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgOutlinedWarning: {
    Enabled: "rgba(249, 83, 83, 0)",
    Hovered: "rgba(249, 83, 83, 0.01)",
    Pressed: "rgba(249, 83, 83, 0.02)",
    Disabled: "rgba(249, 83, 83, 0)"
  },
  bgOntint: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.95)",
    Pressed: "rgba(255, 255, 255, 0.9)",
    Disabled: "rgba(255, 255, 255, 0.4)"
  },
  bgPrimarySubtle: {
    Enabled: "rgba(232, 246, 248, 1)",
    Hovered: "rgba(224, 242, 245, 1)",
    Pressed: "rgba(213, 237, 240, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgClear: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  bgOutlinedSecondary: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0.01)",
    Pressed: "rgba(0, 0, 0, 0.02)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  bgClickNormal: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0.01)",
    Pressed: "rgba(0, 0, 0, 0.02)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  bgPrimarySubdued: {
    Enabled: "rgba(26, 124, 136, 1)",
    Hovered: "rgba(28, 117, 129, 1)",
    Pressed: "rgba(31, 111, 122, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgOutlinedOntint: {
    Enabled: "rgba(255, 255, 255, 0.0)",
    Hovered: "rgba(255, 255, 255, 0.05)",
    Pressed: "rgba(255, 255, 255, 0.1)",
    Disabled: "rgba(255, 255, 255, 0.0)"
  },
  bgInverse: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(247, 247, 247, 1)",
    Pressed: "rgba(240, 240, 240, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  bgOutlinedPrimary: {
    Enabled: "rgba(0, 190, 214, 0)",
    Hovered: "rgba(0, 190, 214, 0.02)",
    Pressed: "rgba(0, 190, 214, 0.03)",
    Disabled: "rgba(0, 190, 214, 0)"
  },
  bgOntintSubdued: {
    Enabled: "rgba(255, 255, 255, 0.4)",
    Hovered: "rgba(255, 255, 255, 0.35)",
    Pressed: "rgba(255, 255, 255, 0.3)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  },
  bgPrimaryDisabledAccent: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  },
  bgTertiaryDisabledAccent: {
    Enabled: "rgba(66, 75, 76, 1)",
    Hovered: "rgba(62, 71, 72, 1)",
    Pressed: "rgba(59, 68, 69, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  },
  bgWarningDisabledAccent: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  },
  bgErrorDisabledAccent: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  }
}, Fe = {
  fgOntint: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgPrimary: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgInverse: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgWarning: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(249, 83, 83, 0.9)",
    Pressed: "rgba(249, 83, 83, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgAccentSubdued: {
    Enabled: "rgba(26, 124, 136, 1)",
    Hovered: "rgba(26, 124, 136, 0.9)",
    Pressed: "rgba(26, 124, 136, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgSupport: {
    Enabled: "rgba(153, 153, 153, 1)",
    Hovered: "rgba(153, 153, 153, 0.9)",
    Pressed: "rgba(153, 153, 153, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgTertiary: {
    Enabled: "rgba(66, 75, 76, 1)",
    Hovered: "rgba(66, 75, 76, 0.9)",
    Pressed: "rgba(66, 75, 76, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgSupportIcon: {
    Enabled: "rgba(204, 204, 204, 1)",
    Hovered: "rgba(204, 204, 204, 0.9)",
    Pressed: "rgba(204, 204, 204, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.1)"
  },
  fgAccent: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgAccentOntint: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 190, 214, 0.4)"
  },
  fgPrimaryOntint: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  fgOutlinedOntint: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  },
  fgInverseDisabledInverse: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(255, 255, 255, 1)"
  },
  fgClear: {
    Enabled: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)"
  }
}, Ye = {
  borderSecondary: {
    Enabled: "rgba(0, 0, 0, 0.06)",
    Hovered: "rgba(0, 0, 0, 0.09)",
    Pressed: "rgba(0, 0, 0, 0.12)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  borderWarning: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  borderOntintSubdued: {
    Enabled: "rgba(255, 255, 255, 0.4)",
    Hovered: "rgba(255, 255, 255, 0.35)",
    Pressed: "rgba(255, 255, 255, 0.3)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  },
  borderClear: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  borderBorder: {
    Enabled: "rgba(0, 0, 0, 0.1)",
    Hovered: "rgba(0, 0, 0, 0.13)",
    Pressed: "rgba(0, 0, 0, 0.15)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  borderError: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  borderPrimary: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  borderBorderSubdued: {
    Enabled: "rgba(0, 0, 0, 0.2)",
    Hovered: "rgba(0, 0, 0, 0.23)",
    Pressed: "rgba(0, 0, 0, 0.25)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  borderErrorDisabledAccent: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  },
  borderTertiaryDisabledAccent: {
    Enabled: "rgba(66, 75, 76, 1)",
    Hovered: "rgba(62, 71, 72, 1)",
    Pressed: "rgba(59, 68, 69, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  },
  borderPrimaryDisabledAccent: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(156, 169, 171, 1)"
  }
}, I = {
  ixBG: ke,
  ixFG: Fe,
  ixBorder: Ye
}, D = (e) => {
  var n, i, o, d, b;
  const a = e.split("/");
  return ((i = (n = a == null ? void 0 : a[0]) == null ? void 0 : n.startsWith) == null ? void 0 : i.call(n, "ix")) ? ((d = (o = I == null ? void 0 : I[a[0]]) == null ? void 0 : o[a[1]]) == null ? void 0 : d[a[2]]) || e : ((b = $ == null ? void 0 : $[a[0]]) == null ? void 0 : b[a[1]]) || e;
}, Ge = {
  B1_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "17px"
  },
  B1_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "17px"
  },
  B1_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "17px"
  },
  B2_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "16px"
  },
  B2_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "16px"
  },
  B2_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "16px"
  },
  B3_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "15px"
  },
  B3_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "15px"
  },
  B3_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "15px"
  },
  B4_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "14px"
  },
  B4_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "14px"
  },
  B4_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "14px"
  },
  B1_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "17px"
  },
  B1_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "17px"
  },
  B1_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "17px"
  },
  B2_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "16px"
  },
  B2_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "16px"
  },
  B2_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "16px"
  },
  B3_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "15px"
  },
  B3_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "15px"
  },
  B3_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "15px"
  },
  B4_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "14px"
  },
  B4_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "14px"
  },
  B4_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "14px"
  }
}, Me = {
  T1_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "21px"
  },
  T1_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "21px"
  },
  T1_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "21px"
  },
  T2_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "19px"
  },
  T2_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "19px"
  },
  T2_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "19px"
  },
  T3_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "17px"
  },
  T3_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "17px"
  },
  T3_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "17px"
  }
}, je = {
  HD1_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "33px"
  },
  HD2_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "30px"
  },
  HD3_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "27px"
  },
  HD4_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "25px"
  },
  HD4_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "25px"
  },
  HD5_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "23px"
  }
}, qe = {
  DP_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "42px"
  },
  DP_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "42px"
  }
}, Ue = {
  Label1_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "17px"
  },
  Label1_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "17px"
  },
  Label1_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "17px"
  },
  Label2_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "16px"
  },
  Label2_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "16px"
  },
  Label2_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "16px"
  },
  Label3_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "15px"
  },
  Label3_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "15px"
  },
  Label3_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "15px"
  },
  Label4_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "14px"
  },
  Label4_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "14px"
  },
  Label4_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "14px"
  },
  Label5_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "12px"
  },
  Label5_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "12px"
  },
  Label5_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "12px"
  },
  Label6_R: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "10px"
  },
  Label6_SB: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "10px"
  },
  Label6_B: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "10px"
  },
  Label1_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "17px"
  },
  Label1_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "17px"
  },
  Label1_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "17px"
  },
  Label2_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "16px"
  },
  Label2_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "16px"
  },
  Label2_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "16px"
  },
  Label3_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "15px"
  },
  Label3_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "15px"
  },
  Label3_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "15px"
  },
  Label4_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "14px"
  },
  Label4_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "14px"
  },
  Label4_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "14px"
  },
  Label5_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "12px"
  },
  Label5_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "12px"
  },
  Label5_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "12px"
  },
  Label6_R_A11Y: {
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "10px"
  },
  Label6_SB_A11Y: {
    fontWeight: "600",
    lineHeight: "140%",
    fontSize: "10px"
  },
  Label6_B_A11Y: {
    fontWeight: "700",
    lineHeight: "140%",
    fontSize: "10px"
  }
}, W = {
  Body: Ge,
  Title: Me,
  Heading: je,
  Display: qe,
  Label: Ue
}, O = (e) => {
  var t;
  const a = e.split("/");
  return ((t = W == null ? void 0 : W[a[0]]) == null ? void 0 : t[a[1]]) || e;
};
function Ve(e) {
  var a = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return a[t] === void 0 && (a[t] = e(t)), a[t];
  };
}
var Ze = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, R = /* @__PURE__ */ Ve(
  function(e) {
    return Ze.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Qe = function() {
  const a = Array.prototype.slice.call(arguments).filter(Boolean), t = {}, n = [];
  a.forEach((o) => {
    (o ? o.split(" ") : []).forEach((b) => {
      if (b.startsWith("atm_")) {
        const [, p] = b.split("_");
        t[p] = b;
      } else
        n.push(b);
    });
  });
  const i = [];
  for (const o in t)
    Object.prototype.hasOwnProperty.call(t, o) && i.push(t[o]);
  return i.push(...n), i.join(" ");
}, be = Qe, Xe = (e) => e.toUpperCase() === e, Ke = (e) => (a) => e.indexOf(a) === -1, he = (e, a) => {
  const t = {};
  return Object.keys(e).filter(Ke(a)).forEach((n) => {
    t[n] = e[n];
  }), t;
};
function Je(e, a, t) {
  const n = he(a, t);
  if (!e) {
    const i = typeof R == "function" ? { default: R } : R;
    Object.keys(n).forEach((o) => {
      i.default(o) || delete n[o];
    });
  }
  return n;
}
var er = (e, a) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const t = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${t}' in the component '${a}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, rr = 0;
function ge(e) {
  let a = "";
  return process.env.NODE_ENV === "test" && (a += `mocked-styled-${rr++}`, e && e.__wyw_meta && e.__wyw_meta.className && (a += ` ${e.__wyw_meta.className}`)), (t) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(t))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const n = (o, d) => {
      const { as: b = e, class: p = a } = o, g = t.propsAsIs === void 0 ? !(typeof b == "string" && b.indexOf("-") === -1 && !Xe(b[0])) : t.propsAsIs, c = Je(g, o, [
        "as",
        "class"
      ]);
      c.ref = d, c.className = t.atomic ? be(t.class, c.className || p) : be(c.className || p, t.class);
      const { vars: h } = t;
      if (h) {
        const u = {};
        for (const S in h) {
          const _ = h[S], m = _[0], z = _[1] || "", w = typeof m == "function" ? m(o) : m;
          er(w, t.name), u[`--${S}`] = `${w}${z}`;
        }
        const H = c.style || {}, T = Object.keys(H);
        T.length > 0 && T.forEach((S) => {
          u[S] = H[S];
        }), c.style = u;
      }
      return e.__wyw_meta && e !== b ? (c.as = b, B.createElement(e, c)) : B.createElement(b, c);
    }, i = B.forwardRef ? B.forwardRef(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const d = he(o, ["innerRef"]);
        return n(d, o.innerRef);
      }
    );
    return i.displayName = t.name, i.__wyw_meta = {
      className: t.class || a,
      extends: e
    }, i;
  };
}
var s = process.env.NODE_ENV !== "production" ? new Proxy(ge, {
  get(e, a) {
    return e(a);
  }
}) : ge;
const A = {
  fixed: {
    smRect: {
      Font: P.Label.Label3_SB,
      Height: 40,
      Radius: 6,
      "x-Padding": 4,
      "x-Gap": 4
    },
    mdRect: {
      Font: P.Label.Label2_SB,
      Height: 48,
      Radius: 8,
      "x-Padding": 8,
      "x-Gap": 6
    },
    lgRect: {
      Font: P.Label.Label1_SB,
      Height: 56,
      Radius: 8,
      "x-Padding": 12,
      "x-Gap": 6
    },
    smRound: {
      Font: P.Label.Label3_SB,
      Height: 48,
      Radius: 24,
      "x-Padding": 8,
      "x-Gap": 4
    },
    mdRound: {
      Font: P.Label.Label2_SB,
      Height: 52,
      Radius: 26,
      "x-Padding": 12,
      "x-Gap": 6
    },
    lgRound: {
      Font: P.Label.Label1_SB,
      Height: 56,
      Radius: 28,
      "x-Padding": 16,
      "x-Gap": 6
    }
  },
  wrap: {
    smRect: {
      Font: P.Label.Label3_SB,
      Height: 40,
      Radius: 6,
      "x-Padding": 16,
      "x-Gap": 4
    },
    mdRect: {
      Font: P.Label.Label2_SB,
      Height: 48,
      Radius: 8,
      "x-Padding": 20,
      "x-Gap": 6
    },
    lgRect: {
      Font: P.Label.Label1_SB,
      Height: 56,
      Radius: 8,
      "x-Padding": 24,
      "x-Gap": 6
    },
    smRound: {
      Font: P.Label.Label3_SB,
      Height: 48,
      Radius: 24,
      "x-Padding": 20,
      "x-Gap": 4
    },
    mdRound: {
      Font: P.Label.Label2_SB,
      Height: 52,
      Radius: 26,
      "x-Padding": 24,
      "x-Gap": 6
    },
    lgRound: {
      Font: P.Label.Label1_SB,
      Height: 56,
      Radius: 28,
      "x-Padding": 28,
      "x-Gap": 6
    }
  }
}, v = {
  ixBG: {
    bgPrimaryToPrimary: {
      Enabled: r.BTN.Primary.value,
      Hovered: r.BTN.PrimaryHovered.value,
      Pressed: r.BTN.PrimaryPressed.value,
      Selected: r.BTN.Primary.value,
      SelectedHovered: r.BTN.PrimaryHovered.value,
      SelectedPressed: r.BTN.PrimaryPressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgSecondaryToTertiary: {
      Enabled: r.BTN.Secondary.value,
      Hovered: r.BTN.SecondaryHovered.value,
      Pressed: r.BTN.SecondaryPressed.value,
      Selected: r.BTN.Tertiary.value,
      SelectedHovered: r.BTN.TertiaryHovered.value,
      SelectedPressed: r.BTN.TertiaryPressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgSecondaryToPrimarySubtle: {
      Enabled: r.BTN.Secondary.value,
      Hovered: r.BTN.SecondaryHovered.value,
      Pressed: r.BTN.SecondaryPressed.value,
      Selected: r.BTN.PrimarySubtle.value,
      SelectedHovered: r.BTN.PrimarySubtleHovered.value,
      SelectedPressed: r.BTN.PrimarySubtlePressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgSecondarySubtleToPrimary: {
      Enabled: r.BTN.SecondarySubtle.value,
      Hovered: r.BTN.SecondarySubtleHovered.value,
      Pressed: r.BTN.SecondarySubtlePressed.value,
      Selected: r.BTN.Primary.value,
      SelectedHovered: r.BTN.PrimaryHovered.value,
      SelectedPressed: r.BTN.PrimaryPressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgTertiaryToTertiary: {
      Enabled: r.BTN.Tertiary.value,
      Hovered: r.BTN.TertiaryHovered.value,
      Pressed: r.BTN.TertiaryPressed.value,
      Selected: r.BTN.Tertiary.value,
      SelectedHovered: r.BTN.TertiaryHovered.value,
      SelectedPressed: r.BTN.TertiaryPressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgWarningToWarning: {
      Enabled: r.BTN.Warning.value,
      Hovered: r.BTN.WarningHovered.value,
      Pressed: r.BTN.WarningPressed.value,
      Selected: r.BTN.Warning.value,
      SelectedHovered: r.BTN.WarningHovered.value,
      SelectedPressed: r.BTN.WarningPressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgWarningOutlinedToWarning: {
      Enabled: r.BTN.LinedWarning.value,
      Hovered: r.BTN.LinedWarningHovered.value,
      Pressed: r.BTN.LinedWarningPressed.value,
      Selected: r.BTN.Warning.value,
      SelectedHovered: r.BTN.WarningHovered.value,
      SelectedPressed: r.BTN.WarningPressed.value,
      Disabled: r.BTN.LinedWarning.value
    },
    bgOntintToOntint: {
      Enabled: r.BTN.OnTint.value,
      Hovered: r.BTN.OnTintHovered.value,
      Pressed: r.BTN.OnTintPressed.value,
      Selected: r.BTN.OnTint.value,
      SelectedHovered: r.BTN.OnTintHovered.value,
      SelectedPressed: r.BTN.OnTintPressed.value,
      Disabled: r.BTN.Disabled.value
    },
    bgOutlinedToTertiary: {
      Enabled: r.BTN.LinedSecondary.value,
      Hovered: r.BTN.LinedSecondaryHovered.value,
      Pressed: r.BTN.LinedSecondaryPressed.value,
      Selected: r.BTN.Tertiary.value,
      SelectedHovered: r.BTN.TertiaryHovered.value,
      SelectedPressed: r.BTN.TertiaryPressed.value,
      Disabled: r.BTN.LinedSecondary.value
    },
    bgOntintOutlinedToOntint: {
      Enabled: r.BTN.LinedOnTint.value,
      Hovered: r.BTN.LinedOnTintHovered.value,
      Pressed: r.BTN.LinedOnTintPressed.value,
      Selected: r.BTN.OnTint.value,
      SelectedHovered: r.BTN.OnTintHovered.value,
      SelectedPressed: r.BTN.OnTintPressed.value,
      Disabled: r.BTN.LinedOnTint.value
    }
  },
  ixFG: {
    fgOntintToOntint: {
      Enabled: r.Text.OnTint.value,
      Hovered: r.Text.OnTintHovered.value,
      Pressed: r.Text.OnTintPressed.value,
      Selected: r.Text.OnTint.value,
      SelectedHovered: r.Text.OnTintHovered.value,
      SelectedPressed: r.Text.OnTintPressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgPrimaryToPrimary: {
      Enabled: r.Text.Primary.value,
      Hovered: r.Text.PrimaryHovered.value,
      Pressed: r.Text.PrimaryPressed.value,
      Selected: r.Text.Primary.value,
      SelectedHovered: r.Text.PrimaryHovered.value,
      SelectedPressed: r.Text.PrimaryPressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgPrimaryToInverse: {
      Enabled: r.Text.Primary.value,
      Hovered: r.Text.PrimaryHovered.value,
      Pressed: r.Text.PrimaryPressed.value,
      Selected: r.Text.Inverse.value,
      SelectedHovered: r.Text.InverseHovered.value,
      SelectedPressed: r.Text.InversePressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgPrimaryToAccent: {
      Enabled: r.Text.Primary.value,
      Hovered: r.Text.PrimaryHovered.value,
      Pressed: r.Text.PrimaryPressed.value,
      Selected: r.Text.Accent.value,
      SelectedHovered: r.Text.AccentHovered.value,
      SelectedPressed: r.Text.AccentPressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgPrimaryToOntint: {
      Enabled: r.Text.Primary.value,
      Hovered: r.Text.PrimaryHovered.value,
      Pressed: r.Text.PrimaryPressed.value,
      Selected: r.Text.OnTint.value,
      SelectedHovered: r.Text.OnTintHovered.value,
      SelectedPressed: r.Text.OnTintPressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgInverseToInverse: {
      Enabled: r.Text.Inverse.value,
      Hovered: r.Text.InverseHovered.value,
      Pressed: r.Text.InversePressed.value,
      Selected: r.Text.Inverse.value,
      SelectedHovered: r.Text.InverseHovered.value,
      SelectedPressed: r.Text.InversePressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgWarningToOntint: {
      Enabled: r.Text.Warning.value,
      Hovered: r.Text.WarningHovered.value,
      Pressed: r.Text.WarningPressed.value,
      Selected: r.Text.OnTint.value,
      SelectedHovered: r.Text.OnTintHovered.value,
      SelectedPressed: r.Text.OnTintPressed.value,
      Disabled: r.Text.Disabled.value
    },
    fgOntintToAccent: {
      Enabled: r.Text.OnTint.value,
      Hovered: r.Text.OnTintHovered.value,
      Pressed: r.Text.OnTintPressed.value,
      Selected: r.Text.Accent.value,
      SelectedHovered: r.Text.AccentHovered.value,
      SelectedPressed: r.Text.AccentPressed.value,
      Disabled: r.Text.Disabled.value
    }
  },
  ixBorder: {
    borderSecondaryToClear: {
      Enabled: r.BTN.Secondary.value,
      Hovered: r.BTN.SecondaryHovered.value,
      Pressed: r.BTN.SecondaryPressed.value,
      Selected: r.BTN.Clear.value,
      SelectedHovered: r.BTN.Clear.value,
      SelectedPressed: r.BTN.Clear.value,
      Disabled: r.BTN.Disabled.value
    },
    borderWarningToClear: {
      Enabled: r.BTN.Warning.value,
      Hovered: r.BTN.WarningHovered.value,
      Pressed: r.BTN.WarningPressed.value,
      Selected: r.BTN.Clear.value,
      SelectedHovered: r.BTN.Clear.value,
      SelectedPressed: r.BTN.Clear.value,
      Disabled: r.BTN.Disabled.value
    },
    borderOntintSubduedToClear: {
      Enabled: r.BTN.OnTintSubdued.value,
      Hovered: r.BTN.OnTintSubduedHovered.value,
      Pressed: r.BTN.OnTintSubduedPressed.value,
      Selected: r.BTN.Clear.value,
      SelectedHovered: r.BTN.Clear.value,
      SelectedPressed: r.BTN.Clear.value,
      Disabled: r.BTN.Disabled.value
    }
  }
}, ye = B.forwardRef(function({
  as: a = "button",
  width: t = "auto",
  sizeType: n = "wrap",
  sizeShape: i = "smRect",
  colorText: o = "fgOntintToOntint",
  colorIcon: d = "fgOntintToOntint",
  colorBg: b = "bgPrimaryToPrimary",
  colorBorder: p,
  icon: g,
  alignIcon: c = "left",
  children: h,
  selected: u = !1,
  disabled: H = !1,
  ...T
}, S) {
  var _, m, z, w, k, F, Y, G, M, j, q, U, V, Z, Q, X, K, J, ee, re, ae, te, ne, oe, ie, le, se;
  return /* @__PURE__ */ f(Dr, {
    as: a,
    $fontSize: A[n][i].Font.value["font-size"],
    $fontWeight: A[n][i].Font.value["font-weight"],
    $lineHeight: A[n][i].Font.value["line-height"],
    $gap: A[n][i]["x-Gap"],
    $width: t,
    $height: A[n][i].Height,
    $radius: A[n][i].Radius,
    $xPadding: A[n][i]["x-Padding"],
    $colorText: u ? (_ = v.ixFG[o]) == null ? void 0 : _.Selected : (m = v.ixFG[o]) == null ? void 0 : m.Enabled,
    $colorIcon: u ? (z = v.ixFG[d]) == null ? void 0 : z.Selected : (w = v.ixFG[d]) == null ? void 0 : w.Enabled,
    $colorBg: u ? (k = v.ixBG[b]) == null ? void 0 : k.Selected : (F = v.ixBG[b]) == null ? void 0 : F.Enabled,
    $colorBorder: u ? (Y = v.ixBorder[p]) == null ? void 0 : Y.Selected : (G = v.ixBorder[p]) == null ? void 0 : G.Enabled,
    $hoverColorText: u ? (M = v.ixFG[o]) == null ? void 0 : M.SelectedHovered : (j = v.ixFG[o]) == null ? void 0 : j.Hovered,
    $hoverColorIcon: u ? (q = v.ixFG[d]) == null ? void 0 : q.SelectedHovered : (U = v.ixFG[d]) == null ? void 0 : U.Hovered,
    $hoverColorBg: u ? (V = v.ixBG[b]) == null ? void 0 : V.SelectedHovered : (Z = v.ixBG[b]) == null ? void 0 : Z.Hovered,
    $hoverColorBorder: u ? (Q = v.ixBorder[p]) == null ? void 0 : Q.SelectedHovered : (X = v.ixBorder[p]) == null ? void 0 : X.Hovered,
    $pressedColorText: u ? (K = v.ixFG[o]) == null ? void 0 : K.SelectedPressed : (J = v.ixFG[o]) == null ? void 0 : J.Pressed,
    $pressedColorIcon: u ? (ee = v.ixFG[d]) == null ? void 0 : ee.SelectedPressed : (re = v.ixFG[d]) == null ? void 0 : re.Pressed,
    $pressedColorBg: u ? (ae = v.ixBG[b]) == null ? void 0 : ae.SelectedPressed : (te = v.ixBG[b]) == null ? void 0 : te.Pressed,
    $pressedColorBorder: (ne = v.ixBorder[p]) == null ? void 0 : ne.Pressed,
    $disabledColorText: (oe = v.ixFG[o]) == null ? void 0 : oe.Disabled,
    $disabledColorIcon: (ie = v.ixFG[d]) == null ? void 0 : ie.Disabled,
    $disabledColorBg: (le = v.ixBG[b]) == null ? void 0 : le.Disabled,
    $disabledColorBorder: (se = v.ixBorder[p]) == null ? void 0 : se.Disabled,
    $alignIcon: c,
    disabled: H,
    ...T,
    ref: S,
    children: [!!g && /* @__PURE__ */ l(Cr, {
      children: g
    }), /* @__PURE__ */ l(Ar, {
      $sizeType: n,
      children: h
    })]
  });
}), ar = () => ({
  $fontSize: e
}) => typeof e == "number" ? `${e}px` : e, tr = () => ({
  $fontWeight: e
}) => typeof e == "number" ? `${e}px` : e, nr = () => ({
  $lineHeight: e
}) => typeof e == "number" ? `${e}px` : e, or = () => ({
  $height: e
}) => typeof e == "number" ? `${e}px` : e, ir = () => ({
  $gap: e
}) => typeof e == "number" ? `${e}px` : e, lr = () => ({
  $radius: e
}) => typeof e == "number" ? `${e}px` : e, sr = () => ({
  $xPadding: e
}) => typeof e == "number" ? `0 ${e}px` : `0 ${e}`, dr = () => ({
  $width: e
}) => typeof e == "number" ? `${e}px` : e, br = () => ({
  $alignIcon: e
}) => e === "right" ? "row-reverse" : "row", gr = () => ({
  $colorBg: e
}) => e || "", cr = () => ({
  $colorText: e
}) => e || "", pr = () => ({
  $colorBorder: e
}) => e ? `1px solid ${e}` : "none", ur = () => ({
  $colorIcon: e
}) => e || "", vr = () => ({
  $hoverColorBg: e
}) => e || "", hr = () => ({
  $hoverColorText: e
}) => e || "", yr = () => ({
  $hoverColorBorder: e
}) => e ? `1px solid ${e}` : "none", fr = () => ({
  $hoverColorIcon: e
}) => e || "", xr = () => ({
  $pressedColorBg: e
}) => e || "", Sr = () => ({
  $pressedColorText: e
}) => e || "", Pr = () => ({
  $pressedColorBorder: e
}) => e ? `1px solid ${e}` : "none", Br = () => ({
  $pressedColorIcon: e
}) => e || "", Hr = () => ({
  $disabledColorBg: e
}) => e || "", Tr = () => ({
  $disabledColorText: e
}) => e || "", _r = () => ({
  $disabledColorBorder: e
}) => e ? `1px solid ${e}` : "none", mr = () => ({
  $disabledColorIcon: e
}) => e || "", Dr = /* @__PURE__ */ s("button")({
  name: "ButtonElement",
  class: "b1cb9caz",
  propsAsIs: !1,
  vars: {
    "b1cb9caz-0": [ar()],
    "b1cb9caz-1": [tr()],
    "b1cb9caz-2": [nr()],
    "b1cb9caz-3": [or()],
    "b1cb9caz-4": [ir()],
    "b1cb9caz-5": [lr()],
    "b1cb9caz-6": [sr()],
    "b1cb9caz-7": [dr()],
    "b1cb9caz-8": [br()],
    "b1cb9caz-9": [gr()],
    "b1cb9caz-10": [cr()],
    "b1cb9caz-11": [pr()],
    "b1cb9caz-12": [ur()],
    "b1cb9caz-13": [vr()],
    "b1cb9caz-14": [hr()],
    "b1cb9caz-15": [yr()],
    "b1cb9caz-16": [fr()],
    "b1cb9caz-17": [xr()],
    "b1cb9caz-18": [Sr()],
    "b1cb9caz-19": [Pr()],
    "b1cb9caz-20": [Br()],
    "b1cb9caz-21": [Hr()],
    "b1cb9caz-22": [Tr()],
    "b1cb9caz-23": [_r()],
    "b1cb9caz-24": [mr()]
  }
}), Cr = /* @__PURE__ */ s("div")({
  name: "Icon",
  class: "i1o067xl",
  propsAsIs: !1
}), Ar = /* @__PURE__ */ s("div")({
  name: "ButtonInner",
  class: "b104vegi",
  propsAsIs: !1
}), Rn = B.forwardRef(function({
  width: a = "100%",
  ...t
}, n) {
  return /* @__PURE__ */ l(ye, {
    ...t,
    width: a,
    sizeType: "fixed",
    ref: n
  });
}), On = B.forwardRef(function({
  ...a
}, t) {
  return /* @__PURE__ */ l(ye, {
    ...a,
    sizeType: "wrap",
    width: "fit-content",
    ref: t
  });
}), Er = /* @__PURE__ */ l("svg", { width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.25C16 12.6683 12.4183 16.25 8 16.25C3.58172 16.25 0 12.6683 0 8.25C0 3.83172 3.58172 0.25 8 0.25C12.4183 0.25 16 3.83172 16 8.25ZM4.75503 5.00502C4.48166 5.27839 4.48166 5.72161 4.75502 5.99497L7.01116 8.25112L4.75576 10.5065C4.48239 10.7799 4.48239 11.2231 4.75576 11.4965C5.02913 11.7698 5.47234 11.7698 5.74571 11.4965L8.00111 9.24107L10.2565 11.4965C10.5299 11.7698 10.9731 11.7698 11.2465 11.4965C11.5198 11.2231 11.5198 10.7799 11.2465 10.5065L8.99106 8.25112L11.2472 5.99497C11.5206 5.72161 11.5206 5.27839 11.2472 5.00502C10.9738 4.73166 10.5306 4.73166 10.2572 5.00503L8.00111 7.26117L5.74498 5.00503C5.47161 4.73166 5.02839 4.73166 4.75503 5.00502Z",
    fill: "#999999"
  }
) }), wr = /* @__PURE__ */ l("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50005 0.30069C3.07588 0.30069 0.300049 3.07652 0.300049 6.50069C0.300049 9.92486 3.07588 12.7007 6.50005 12.7007C7.94196 12.7007 9.26891 12.2085 10.322 11.3829L14.2196 15.2804C14.5125 15.5733 14.9873 15.5733 15.2802 15.2804C15.5731 14.9875 15.5731 14.5126 15.2802 14.2197L11.3826 10.3222C12.208 9.26913 12.7 7.94237 12.7 6.50069C12.7 3.07652 9.92421 0.30069 6.50005 0.30069ZM1.70005 6.50069C1.70005 3.84972 3.84908 1.70069 6.50005 1.70069C9.15102 1.70069 11.3 3.84972 11.3 6.50069C11.3 9.15166 9.15102 11.3007 6.50005 11.3007C3.84908 11.3007 1.70005 9.15166 1.70005 6.50069Z",
    fill: "#CCCCCC"
  }
) }), Nn = B.forwardRef(function({
  containerProps: a,
  icon: t,
  width: n = "100%",
  helpText: i = "",
  errorText: o = "",
  maxLength: d = 30,
  hasCounter: b = !1,
  onClickDelete: p,
  alertPosition: g = "static",
  ...c
}, h) {
  const [u, H] = ve(0);
  return /* @__PURE__ */ f(zr, {
    ...a,
    children: [/* @__PURE__ */ f(Lr, {
      children: [!!t && /* @__PURE__ */ l($r, {
        children: t === "search" ? wr : t
      }), /* @__PURE__ */ l(Or, {
        $width: n,
        $hasIcon: !!t,
        $hasError: !!o,
        maxLength: d,
        ...c,
        onChange: (T) => {
          var S, _, m;
          (S = c == null ? void 0 : c.onChange) == null || S.call(c, T), H(((m = (_ = T == null ? void 0 : T.currentTarget) == null ? void 0 : _.value) == null ? void 0 : m.length) || 0);
        },
        ref: h
      }), !!p && /* @__PURE__ */ l(Nr, {
        className: "input-delete",
        onClick: p,
        children: Er
      })]
    }), /* @__PURE__ */ f(kr, {
      style: g === "static" ? {
        position: "static"
      } : {
        position: "absolute",
        top: "calc(100%)",
        left: 0,
        right: 0
      },
      children: [/* @__PURE__ */ f(Fr, {
        children: [!!i && !o && /* @__PURE__ */ l(Mr, {
          $disabled: c == null ? void 0 : c.disabled,
          children: i
        }), !!o && /* @__PURE__ */ l(Yr, {
          children: o
        })]
      }), !!b && !!d && /* @__PURE__ */ f(qr, {
        $disabled: c == null ? void 0 : c.disabled,
        className: "input-counter",
        children: [Math.min(u, d), "/", d]
      })]
    })]
  });
}), zr = /* @__PURE__ */ s("div")({
  name: "Container",
  class: "ciydouz",
  propsAsIs: !1
}), Lr = /* @__PURE__ */ s("div")({
  name: "Wrapper",
  class: "w1xo91h4",
  propsAsIs: !1
}), $r = /* @__PURE__ */ s("div")({
  name: "Icon",
  class: "i1inltlm",
  propsAsIs: !1
}), Ir = () => ({
  $hasIcon: e
}) => e ? "40px" : "16px", Wr = () => ({
  $width: e
}) => typeof e == "number" ? `${e}px` : e, Rr = () => ({
  $hasError: e
}) => e ? `0 0 0 2px ${x("Text/Error")}` : "none", Or = /* @__PURE__ */ s("input")({
  name: "InputElement",
  class: "ilmz20e",
  propsAsIs: !1,
  vars: {
    "ilmz20e-0": [Ir()],
    "ilmz20e-1": [Wr()],
    "ilmz20e-2": [Rr()]
  }
}), Nr = /* @__PURE__ */ s("div")({
  name: "InputDeleteIcon",
  class: "i1os6etf",
  propsAsIs: !1
}), kr = /* @__PURE__ */ s("div")({
  name: "BottomLine",
  class: "b6fqpsj",
  propsAsIs: !1
}), Fr = /* @__PURE__ */ s("div")({
  name: "Message",
  class: "m1o9af9p",
  propsAsIs: !1
}), Yr = /* @__PURE__ */ s("div")({
  name: "ErrorMessage",
  class: "e1lkkn9s",
  propsAsIs: !1
}), Gr = () => ({
  $disabled: e
}) => x(e ? "Text/Disabled" : "Text/Support"), Mr = /* @__PURE__ */ s("div")({
  name: "HelpMessage",
  class: "hbxyra5",
  propsAsIs: !1,
  vars: {
    "hbxyra5-0": [Gr()]
  }
}), jr = () => ({
  $disabled: e
}) => x(e ? "Text/Disabled" : "Text/Support"), qr = /* @__PURE__ */ s("div")({
  name: "CharacterCounter",
  class: "c1odegx7",
  propsAsIs: !1,
  vars: {
    "c1odegx7-0": [jr()]
  }
}), Ur = B.forwardRef(function({
  type: a = "Body/B1_R",
  as: t = "div",
  color: n,
  children: i,
  ...o
}, d) {
  const b = ze(a);
  return /* @__PURE__ */ l(Kr, {
    as: t,
    $fontSize: b["font-size"],
    $fontWeight: b["font-weight"],
    $lineHeight: b["line-height"],
    $color: n ? x(n) : void 0,
    ...o,
    ref: d,
    children: i
  });
}), Vr = () => ({
  $fontSize: e
}) => typeof e == "number" ? `${e}px` : e, Zr = () => ({
  $fontWeight: e
}) => typeof e == "number" ? `${e}px` : e, Qr = () => ({
  $lineHeight: e
}) => typeof e == "number" ? `${e}px` : e, Xr = () => ({
  $color: e
}) => e || "inherit", Kr = /* @__PURE__ */ s("div")({
  name: "TextElement",
  class: "tlqf8r7",
  propsAsIs: !1,
  vars: {
    "tlqf8r7-0": [Vr()],
    "tlqf8r7-1": [Zr()],
    "tlqf8r7-2": [Qr()],
    "tlqf8r7-3": [Xr()]
  }
}), Jr = /* @__PURE__ */ l("svg", { width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.1C12.1451 15.1 15.1 12.1451 15.1 8.5C15.1 4.85492 12.1451 1.9 8.5 1.9C4.85492 1.9 1.9 4.85492 1.9 8.5C1.9 12.1451 4.85492 15.1 8.5 15.1ZM16.5 8.5C16.5 12.9183 12.9183 16.5 8.5 16.5C4.08172 16.5 0.5 12.9183 0.5 8.5C0.5 4.08172 4.08172 0.5 8.5 0.5C12.9183 0.5 16.5 4.08172 16.5 8.5ZM8.5 4.3C8.8866 4.3 9.2 4.6134 9.2 5V9.5C9.2 9.8866 8.8866 10.2 8.5 10.2C8.1134 10.2 7.8 9.8866 7.8 9.5V5C7.8 4.6134 8.1134 4.3 8.5 4.3ZM9.2 12C9.2 11.6134 8.8866 11.3 8.5 11.3C8.1134 11.3 7.8 11.6134 7.8 12V12.5C7.8 12.8866 8.1134 13.2 8.5 13.2C8.8866 13.2 9.2 12.8866 9.2 12.5V12Z",
    fill: "#FFFFFF"
  }
) }), kn = B.forwardRef(function({
  color: a = "Surface/Tertiary",
  arrowDirection: t = "down",
  icon: n,
  arrowOffset: i = 24,
  alignment: o = "left",
  width: d = "fit-content",
  position: b = "relative",
  inset: p,
  className: g,
  children: c,
  ...h
}, u) {
  return /* @__PURE__ */ f(ba, {
    className: g ? `tooltip ${g}` : "tooltip",
    $backgroundColor: a,
    $arrowDirection: t,
    $arrowOffset: i,
    $alignment: o,
    $width: d,
    $position: b,
    $inset: p,
    ...h,
    ref: u,
    children: [!!n && /* @__PURE__ */ l(ga, {
      children: n === "warning" ? Jr : n
    }), c]
  });
}), ea = () => ({
  $position: e
}) => e, ra = () => ({
  $inset: e
}) => e || "", aa = () => ({
  $width: e
}) => typeof e == "number" ? `${e}px` : e, ta = () => ({
  $backgroundColor: e
}) => x(e), na = () => ({
  $alignment: e
}) => e === "left" ? "flex-start" : e === "center" ? "center" : "flex-end", oa = () => ({
  $arrowDirection: e
}) => e === "down" ? "calc(100% - 1px)" : "", ia = () => ({
  $arrowDirection: e
}) => e === "up" ? "calc(100% - 1px)" : "", la = () => ({
  $alignment: e,
  $arrowOffset: a
}) => e === "left" ? `${a}px` : e === "center" ? "50%" : "", sa = () => ({
  $alignment: e,
  $arrowOffset: a
}) => e === "right" ? `${a}px` : "", da = () => ({
  $arrowDirection: e,
  $backgroundColor: a
}) => e === "down" ? `${x(a)} transparent transparent transparent` : `transparent transparent ${x(a)} transparent`, ba = /* @__PURE__ */ s("div")({
  name: "Container",
  class: "c1e01rlk",
  propsAsIs: !1,
  vars: {
    "c1e01rlk-0": [ea()],
    "c1e01rlk-1": [ra()],
    "c1e01rlk-2": [aa()],
    "c1e01rlk-3": [ta()],
    "c1e01rlk-4": [na()],
    "c1e01rlk-5": [oa()],
    "c1e01rlk-6": [ia()],
    "c1e01rlk-7": [la()],
    "c1e01rlk-8": [sa()],
    "c1e01rlk-9": [da()]
  }
}), ga = /* @__PURE__ */ s("div")({
  name: "Icon",
  class: "ix07uk0",
  propsAsIs: !1
}), Fn = B.forwardRef(function({
  as: a = "p",
  color: t = "Text/Primary",
  background: n,
  children: i,
  ...o
}, d) {
  return /* @__PURE__ */ l(ua, {
    as: a,
    $color: t,
    $background: n || "none",
    ...o,
    ref: d,
    children: i
  });
}), ca = () => ({
  $color: e
}) => x(e), pa = () => ({
  $background: e
}) => x(e), ua = /* @__PURE__ */ s("p")({
  name: "TitleElement",
  class: "tglwz6r",
  propsAsIs: !1,
  vars: {
    "tglwz6r-0": [ca()],
    "tglwz6r-1": [pa()]
  }
}), Yn = B.forwardRef(function({
  color: a = "Surface/Divider",
  margin: t = 0,
  ...n
}, i) {
  return /* @__PURE__ */ l(ya, {
    $color: x(a),
    $margin: t,
    ...n,
    ref: i,
    children: null
  });
}), va = () => ({
  $margin: e
}) => typeof e == "number" ? `0 ${e}px` : e, ha = () => ({
  $color: e
}) => e, ya = /* @__PURE__ */ s("div")({
  name: "DividerElement",
  class: "d1cg1l0x",
  propsAsIs: !1,
  vars: {
    "d1cg1l0x-0": [va()],
    "d1cg1l0x-1": [ha()]
  }
}), fa = /* @__PURE__ */ l("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0653 19.003C18.3387 19.2764 18.7819 19.2764 19.0553 19.003C19.3286 18.7296 19.3286 18.2864 19.0553 18.0131L13.0096 11.9674L19.0553 5.92171C19.3286 5.64835 19.3286 5.20513 19.0553 4.93176C18.7819 4.6584 18.3387 4.6584 18.0653 4.93176L12.0196 10.9774L5.97378 4.93159C5.70042 4.65822 5.2572 4.65822 4.98383 4.93159C4.71047 5.20495 4.71047 5.64817 4.98383 5.92154L11.0297 11.9674L4.98383 18.0132C4.71047 18.2866 4.71047 18.7298 4.98383 19.0032C5.2572 19.2766 5.70042 19.2766 5.97378 19.0032L12.0196 12.9573L18.0653 19.003Z",
    fill: "#262626"
  }
) }), xa = /* @__PURE__ */ l("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2448 5.49496C11.5181 5.2216 11.5181 4.77838 11.2448 4.50501C10.9714 4.23165 10.5282 4.23165 10.2548 4.50501L3.25483 11.505C2.98146 11.7784 2.98146 12.2216 3.25483 12.495L10.2548 19.495C10.5282 19.7683 10.9714 19.7683 11.2448 19.495C11.5181 19.2216 11.5181 18.7784 11.2448 18.505L5.43682 12.6971H20.3937C20.7803 12.6971 21.0938 12.3837 21.0938 11.9971C21.0938 11.6105 20.7803 11.2971 20.3937 11.2971H5.44268L11.2448 5.49496Z",
    fill: "#262626"
  }
) }), Gn = B.forwardRef(function({
  title: a,
  background: t = "BG/Primary",
  color: n = "Text/Primary",
  iconWidth: i = "auto",
  leftIcon: o = "leftArrow",
  rightIcon: d = null,
  zIndex: b = 0,
  onClickTitle: p,
  onClickLeftIcon: g,
  onClickRightIcon: c,
  containerAttrs: h
}, u) {
  return /* @__PURE__ */ f(Ba, {
    ...h,
    $background: t ? x(t) : "none",
    $zIndex: b,
    ref: u,
    children: [/* @__PURE__ */ l(ce, {
      style: {
        cursor: g ? "pointer" : "default"
      },
      onClick: () => g == null ? void 0 : g(),
      $width: i,
      children: (() => {
        switch (o) {
          case "leftArrow":
            return xa;
          case "close":
            return fa;
          default:
            return o;
        }
      })()
    }), /* @__PURE__ */ l(Ta, {
      as: typeof a == "string" ? "h1" : void 0,
      style: {
        cursor: p ? "pointer" : "default"
      },
      onClick: () => p == null ? void 0 : p(),
      $color: x(n),
      children: a
    }), /* @__PURE__ */ l(ce, {
      style: {
        cursor: c ? "pointer" : "default"
      },
      onClick: () => c == null ? void 0 : c(),
      $width: i,
      children: (() => {
        switch (d) {
          default:
            return d;
        }
      })()
    })]
  });
}), Sa = () => ({
  $zIndex: e
}) => e, Pa = () => ({
  $background: e
}) => e, Ba = /* @__PURE__ */ s("div")({
  name: "Top",
  class: "t1whfyp5",
  propsAsIs: !1,
  vars: {
    "t1whfyp5-0": [Sa()],
    "t1whfyp5-1": [Pa()]
  }
}), Ha = () => ({
  $color: e
}) => e, Ta = /* @__PURE__ */ s("div")({
  name: "Title",
  class: "t1210fq6",
  propsAsIs: !1,
  vars: {
    "t1210fq6-0": [Ha()]
  }
}), _a = () => ({
  $width: e
}) => typeof e == "number" ? `${e}px` : e, ce = /* @__PURE__ */ s("div")({
  name: "Icon",
  class: "irfs8c4",
  propsAsIs: !1,
  vars: {
    "irfs8c4-0": [_a()]
  }
}), Mn = B.forwardRef(function({
  children: a,
  padding: t = "24px 24px 10px 24px",
  background: n,
  fontType: i = "Title/T2_SB",
  leftIcon: o,
  subIcon: d,
  as: b,
  right: p,
  containerAttrs: g,
  rightAttrs: c,
  ...h
}, u) {
  return /* @__PURE__ */ f(Ca, {
    $padding: t,
    $background: n ? x(n) : "none",
    ...g,
    children: [/* @__PURE__ */ f(Aa, {
      children: [!!o && /* @__PURE__ */ l(Ea, {
        children: o
      }), /* @__PURE__ */ l(Ur, {
        ...h,
        as: b,
        type: i,
        ref: u,
        children: a
      }), !!d && /* @__PURE__ */ l(wa, {
        children: d
      })]
    }), /* @__PURE__ */ l(za, {
      ...c,
      children: p
    })]
  });
}), ma = () => ({
  $padding: e
}) => e, Da = () => ({
  $background: e
}) => e, Ca = /* @__PURE__ */ s("div")({
  name: "Container",
  class: "czl6bvf",
  propsAsIs: !1,
  vars: {
    "czl6bvf-0": [ma()],
    "czl6bvf-1": [Da()]
  }
}), Aa = /* @__PURE__ */ s("div")({
  name: "LeftWrapper",
  class: "l6op8fj",
  propsAsIs: !1
}), Ea = /* @__PURE__ */ s("div")({
  name: "LeftIcon",
  class: "l115bsgu",
  propsAsIs: !1
}), wa = /* @__PURE__ */ s("div")({
  name: "SubIcon",
  class: "s1ub5kb1",
  propsAsIs: !1
}), za = /* @__PURE__ */ s("div")({
  name: "Right",
  class: "r6uwfe3",
  propsAsIs: !1
});
function La(e) {
  return (a) => {
    e.forEach((t) => {
      typeof t == "function" ? t(a) : t != null && (t.current = a);
    });
  };
}
const jn = B.forwardRef(function({
  containerProps: a,
  bottomLineAttrs: t,
  width: n = "100%",
  helpText: i = "",
  errorText: o = "",
  maxLength: d = 200,
  hasCounter: b = !0,
  // onClickDelete,
  alertPosition: p = "static",
  ...g
}, c) {
  var S, _;
  const h = de(null), u = de(null), [H, T] = ve(null);
  return xe(() => {
    u.current && T(u.current.scrollHeight);
  }, [g.value]), /* @__PURE__ */ l($a, {
    ...a,
    children: /* @__PURE__ */ f(Ia, {
      children: [/* @__PURE__ */ l(pe, {
        $width: n,
        $hasError: !!o,
        maxLength: d,
        ...g,
        style: {
          ...g.style,
          height: "auto",
          visibility: "hidden",
          position: "absolute",
          userSelect: "none"
        },
        readOnly: !0,
        disabled: !0,
        ref: u
      }), /* @__PURE__ */ l(pe, {
        $width: n,
        $hasError: !!o,
        maxLength: d,
        ...g,
        style: {
          ...g.style,
          height: H || "auto"
        },
        ref: La([c, h])
      }), /* @__PURE__ */ f(Oa, {
        ...t,
        style: {
          ...p === "static" ? {
            position: "static"
          } : {
            position: "absolute",
            top: "calc(100%)",
            left: 0,
            right: 0
          },
          ...t == null ? void 0 : t.style
        },
        children: [/* @__PURE__ */ f(Na, {
          children: [!!i && !o && /* @__PURE__ */ l(Ya, {
            $disabled: g == null ? void 0 : g.disabled,
            children: i
          }), !!o && /* @__PURE__ */ l(ka, {
            children: o
          })]
        }), !!b && !!d && /* @__PURE__ */ f(Ma, {
          $disabled: g == null ? void 0 : g.disabled,
          className: "input-counter",
          children: [((_ = (S = g == null ? void 0 : g.value) == null ? void 0 : S.toString()) == null ? void 0 : _.length) || 0, "/", d]
        })]
      })]
    })
  });
}), $a = /* @__PURE__ */ s("div")({
  name: "Container",
  class: "c13ol3h6",
  propsAsIs: !1
}), Ia = /* @__PURE__ */ s("div")({
  name: "Wrapper",
  class: "w1t4hm65",
  propsAsIs: !1
}), Wa = () => ({
  $width: e
}) => typeof e == "number" ? `${e}px` : e, Ra = () => ({
  $hasError: e
}) => e ? `0 0 0 2px ${x("Text/Error")}` : "none", pe = /* @__PURE__ */ s("textarea")({
  name: "TextAreaElement",
  class: "t1ld5cie",
  propsAsIs: !1,
  vars: {
    "t1ld5cie-0": [Wa()],
    "t1ld5cie-1": [Ra()]
  }
}), Oa = /* @__PURE__ */ s("div")({
  name: "BottomLine",
  class: "bju4qc9",
  propsAsIs: !1
}), Na = /* @__PURE__ */ s("div")({
  name: "Message",
  class: "ms90amm",
  propsAsIs: !1
}), ka = /* @__PURE__ */ s("div")({
  name: "ErrorMessage",
  class: "e127438f",
  propsAsIs: !1
}), Fa = () => ({
  $disabled: e
}) => x(e ? "Text/Disabled" : "Text/Support"), Ya = /* @__PURE__ */ s("div")({
  name: "HelpMessage",
  class: "hum1str",
  propsAsIs: !1,
  vars: {
    "hum1str-0": [Fa()]
  }
}), Ga = () => ({
  $disabled: e
}) => x(e ? "Text/Disabled" : "Text/Support"), Ma = /* @__PURE__ */ s("div")({
  name: "CharacterCounter",
  class: "c1id5i6t",
  propsAsIs: !1,
  vars: {
    "c1id5i6t-0": [Ga()]
  }
}), ue = {
  Line: {
    width: "100%",
    lineHeight: 1,
    lineBackgroundColor: D("Surface/Divider")
  },
  Section: {
    width: "100%",
    lineHeight: 1,
    lineColor: D("Surface/Divider"),
    sectionHeight: 10,
    sectionBackgroundColor: D("BG/Secondary")
  }
}, ja = {
  Page: 24,
  Card: 20,
  Full: 0,
  Section: 0
}, qn = C(function({
  dividerType: a = "Line",
  marginType: t = "Page"
}, n) {
  const i = ja[t];
  switch (a) {
    case "Line":
      return /* @__PURE__ */ l(Qa, {
        ...ue.Line,
        sideMargin: i,
        ref: n
      });
    case "Section":
      return /* @__PURE__ */ l(at, {
        ...ue.Section,
        sideMargin: i,
        ref: n
      });
  }
}), qa = () => ({
  width: e
}) => e, Ua = () => ({
  lineHeight: e
}) => e, Va = () => ({
  lineBackgroundColor: e
}) => e, Za = () => ({
  sideMargin: e
}) => e, Qa = /* @__PURE__ */ s("div")({
  name: "LineDivider",
  class: "l1gfob9l",
  propsAsIs: !1,
  vars: {
    "l1gfob9l-0": [qa()],
    "l1gfob9l-1": [Ua(), "px"],
    "l1gfob9l-2": [Va()],
    "l1gfob9l-3": [Za(), "px"]
  }
}), Xa = () => ({
  width: e
}) => e, Ka = () => ({
  sideMargin: e
}) => e, Ja = () => ({
  lineHeight: e,
  lineColor: a
}) => `${e}px solid ${a}`, et = () => ({
  sectionHeight: e
}) => e, rt = () => ({
  sectionBackgroundColor: e
}) => e, at = /* @__PURE__ */ s("div")({
  name: "SectionDivider",
  class: "srqradj",
  propsAsIs: !1,
  vars: {
    "srqradj-0": [Xa()],
    "srqradj-1": [Ka(), "px"],
    "srqradj-2": [Ja()],
    "srqradj-3": [et(), "px"],
    "srqradj-4": [rt()]
  }
}), tt = {
  Standard: D("Text/Primary"),
  OnTint: D("Text/OnTint")
}, Un = C(function({
  titleColor: a = "Standard",
  containerColor: t = "Surface/Clear",
  titleText: n
}, i) {
  return /* @__PURE__ */ l(it, {
    titleColor: a,
    containerColor: t,
    ref: i,
    children: n
  });
}), nt = () => ({
  titleColor: e
}) => tt[e], ot = () => ({
  containerColor: e
}) => D(e), it = /* @__PURE__ */ s("p")({
  name: "MainContainer",
  class: "msq2hzd",
  propsAsIs: !1,
  vars: {
    "msq2hzd-0": [nt()],
    "msq2hzd-1": [ot()]
  }
}), lt = {
  Large: "Title/T1_B",
  Medium: "Title/T2_SB",
  Small: "Title/T3_SB"
}, Vn = C(function({
  backgroundColor: a = "Surface/Clear",
  containerType: t = "Section",
  leftIconImage: n,
  titleText: i = "섹션타이틀",
  titleType: o = "Large",
  titleSubIconImage: d,
  titleSubIconForegroundColor: b = "ixFG/fgSupport",
  onClickSubIcon: p,
  right: g
}, c) {
  const {
    fontWeight: h,
    lineHeight: u,
    fontSize: H
  } = O(lt[o]);
  return /* @__PURE__ */ f(pt, {
    backgroundColor: a,
    containerType: t,
    fontWeight: h,
    lineHeight: u,
    fontSize: H,
    children: [/* @__PURE__ */ f(ut, {
      children: [n && /* @__PURE__ */ l(vt, {
        children: n
      }), i, d && /* @__PURE__ */ l(ft, {
        titleSubIconForegroundColor: b,
        onClick: p,
        children: d
      })]
    }), g && /* @__PURE__ */ l(xt, {
      children: g
    })]
  });
}), st = () => ({
  backgroundColor: e
}) => D(e), dt = () => ({
  containerType: e
}) => `${{
  Section: {
    left: 24,
    right: 24,
    top: 24,
    bottom: 10
  },
  Card: {
    left: 20,
    right: 20,
    top: 24,
    bottom: 10
  }
}[e].top}px ${{
  Section: {
    left: 24,
    right: 24,
    top: 24,
    bottom: 10
  },
  Card: {
    left: 20,
    right: 20,
    top: 24,
    bottom: 10
  }
}[e].right}px ${{
  Section: {
    left: 24,
    right: 24,
    top: 24,
    bottom: 10
  },
  Card: {
    left: 20,
    right: 20,
    top: 24,
    bottom: 10
  }
}[e].bottom}px ${{
  Section: {
    left: 24,
    right: 24,
    top: 24,
    bottom: 10
  },
  Card: {
    left: 20,
    right: 20,
    top: 24,
    bottom: 10
  }
}[e].left}px`, bt = () => ({
  fontWeight: e
}) => e, gt = () => ({
  lineHeight: e
}) => e, ct = () => ({
  fontSize: e
}) => e, pt = /* @__PURE__ */ s("div")({
  name: "MainContainer",
  class: "m18anh7q",
  propsAsIs: !1,
  vars: {
    "m18anh7q-0": [st()],
    "m18anh7q-1": [dt()],
    "m18anh7q-2": [bt()],
    "m18anh7q-3": [gt()],
    "m18anh7q-4": [ct()]
  }
}), ut = /* @__PURE__ */ s("div")({
  name: "SectionTitleContainer",
  class: "s1svlvfz",
  propsAsIs: !1
}), vt = /* @__PURE__ */ s("div")({
  name: "LeftContainer",
  class: "l16yeih7",
  propsAsIs: !1
}), ht = () => ({
  titleSubIconForegroundColor: e
}) => D(`${e}/Enabled`), yt = () => ({
  titleSubIconForegroundColor: e
}) => D(`${e}/Pressed`), ft = /* @__PURE__ */ s("div")({
  name: "TitleSubIconContainer",
  class: "tczpkdu",
  propsAsIs: !1,
  vars: {
    "tczpkdu-0": [ht()],
    "tczpkdu-1": [yt()]
  }
}), xt = /* @__PURE__ */ s("div")({
  name: "RightContentContainer",
  class: "rrvol0j",
  propsAsIs: !1
}), St = {
  backgroundColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Pt = {
  backgroundColor: {
    Enabled: "rgba(232, 246, 248, 1)",
    Hovered: "rgba(224, 242, 245, 1)",
    Pressed: "rgba(213, 237, 240, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Bt = {
  backgroundColor: {
    Enabled: "rgba(232, 246, 248, 1)",
    Hovered: "rgba(224, 242, 245, 1)",
    Pressed: "rgba(213, 237, 240, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(26, 124, 136, 1)",
    Hovered: "rgba(26, 124, 136, 0.9)",
    Pressed: "rgba(26, 124, 136, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(26, 124, 136, 1)",
    Hovered: "rgba(26, 124, 136, 0.9)",
    Pressed: "rgba(26, 124, 136, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Ht = {
  backgroundColor: {
    Enabled: "rgba(26, 124, 136, 1)",
    Hovered: "rgba(28, 117, 129, 1)",
    Pressed: "rgba(31, 111, 122, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Tt = {
  backgroundColor: {
    Enabled: "rgba(0, 190, 214, 0)",
    Hovered: "rgba(0, 190, 214, 0.02)",
    Pressed: "rgba(0, 190, 214, 0.03)",
    Disabled: "rgba(0, 190, 214, 0)"
  },
  iconColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  }
}, _t = {
  backgroundColor: {
    Enabled: "rgba(240, 240, 240, 1)",
    Hovered: "rgba(235, 235, 235, 1)",
    Pressed: "rgba(230, 230, 230, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, mt = {
  backgroundColor: {
    Enabled: "rgba(240, 240, 240, 1)",
    Hovered: "rgba(235, 235, 235, 1)",
    Pressed: "rgba(230, 230, 230, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(249, 83, 83, 0.9)",
    Pressed: "rgba(249, 83, 83, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Dt = {
  backgroundColor: {
    Enabled: "rgba(240, 240, 240, 1)",
    Hovered: "rgba(235, 235, 235, 1)",
    Pressed: "rgba(230, 230, 230, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(204, 204, 204, 1)",
    Hovered: "rgba(204, 204, 204, 0.9)",
    Pressed: "rgba(204, 204, 204, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.1)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Ct = {
  backgroundColor: {
    Enabled: "rgba(247, 247, 247, 1)",
    Hovered: "rgba(245, 245, 245, 1)",
    Pressed: "rgba(242, 242, 242, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, At = {
  backgroundColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0.01)",
    Pressed: "rgba(0, 0, 0, 0.02)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  iconColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0.06)",
    Hovered: "rgba(0, 0, 0, 0.09)",
    Pressed: "rgba(0, 0, 0, 0.12)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  }
}, Et = {
  backgroundColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0.01)",
    Pressed: "rgba(0, 0, 0, 0.02)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  iconColor: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(249, 83, 83, 0.9)",
    Pressed: "rgba(249, 83, 83, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0.06)",
    Hovered: "rgba(0, 0, 0, 0.09)",
    Pressed: "rgba(0, 0, 0, 0.12)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  }
}, wt = {
  backgroundColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0.01)",
    Pressed: "rgba(0, 0, 0, 0.02)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  iconColor: {
    Enabled: "rgba(204, 204, 204, 1)",
    Hovered: "rgba(204, 204, 204, 0.9)",
    Pressed: "rgba(204, 204, 204, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.1)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0.06)",
    Hovered: "rgba(0, 0, 0, 0.09)",
    Pressed: "rgba(0, 0, 0, 0.12)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  }
}, zt = {
  backgroundColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0.01)",
    Pressed: "rgba(0, 0, 0, 0.02)",
    Disabled: "rgba(0, 0, 0, 0)"
  },
  iconColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0.06)",
    Hovered: "rgba(0, 0, 0, 0.09)",
    Pressed: "rgba(0, 0, 0, 0.12)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  }
}, Lt = {
  backgroundColor: {
    Enabled: "rgba(66, 75, 76, 1)",
    Hovered: "rgba(62, 71, 72, 1)",
    Pressed: "rgba(59, 68, 69, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, $t = {
  backgroundColor: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, It = {
  backgroundColor: {
    Enabled: "rgba(249, 83, 83, 0)",
    Hovered: "rgba(249, 83, 83, 0.01)",
    Pressed: "rgba(249, 83, 83, 0.02)",
    Disabled: "rgba(249, 83, 83, 0)"
  },
  iconColor: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(249, 83, 83, 0.9)",
    Pressed: "rgba(249, 83, 83, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(249, 83, 83, 0.9)",
    Pressed: "rgba(249, 83, 83, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(249, 83, 83, 1)",
    Hovered: "rgba(244, 78, 78, 1)",
    Pressed: "rgba(232, 74, 74, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  }
}, Wt = {
  backgroundColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.95)",
    Pressed: "rgba(255, 255, 255, 0.9)",
    Disabled: "rgba(255, 255, 255, 0.4)"
  },
  iconColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Rt = {
  backgroundColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.95)",
    Pressed: "rgba(255, 255, 255, 0.9)",
    Disabled: "rgba(255, 255, 255, 0.4)"
  },
  iconColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 190, 214, 0.4)"
  },
  labelColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 190, 214, 0.4)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Ot = {
  backgroundColor: {
    Enabled: "rgba(255, 255, 255, 0.4)",
    Hovered: "rgba(255, 255, 255, 0.35)",
    Pressed: "rgba(255, 255, 255, 0.3)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  },
  iconColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(0, 190, 214, 1)",
    Hovered: "rgba(0, 185, 208, 1)",
    Pressed: "rgba(0, 180, 203, 1)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Nt = {
  backgroundColor: {
    Enabled: "rgba(255, 255, 255, 0.0)",
    Hovered: "rgba(255, 255, 255, 0.05)",
    Pressed: "rgba(255, 255, 255, 0.1)",
    Disabled: "rgba(255, 255, 255, 0.0)"
  },
  iconColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(255, 255, 255, 0.9)",
    Pressed: "rgba(255, 255, 255, 0.8)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(255, 255, 255, 0.4)",
    Hovered: "rgba(255, 255, 255, 0.35)",
    Pressed: "rgba(255, 255, 255, 0.3)",
    Disabled: "rgba(255, 255, 255, 0.2)"
  }
}, kt = {
  backgroundColor: {
    Enabled: "rgba(255, 255, 255, 1)",
    Hovered: "rgba(247, 247, 247, 1)",
    Pressed: "rgba(240, 240, 240, 1)",
    Disabled: "rgba(0, 0, 0, 0.05)"
  },
  iconColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  labelColor: {
    Enabled: "rgba(38, 38, 38, 1)",
    Hovered: "rgba(38, 38, 38, 0.9)",
    Pressed: "rgba(38, 38, 38, 0.8)",
    Disabled: "rgba(0, 0, 0, 0.2)"
  },
  borderColor: {
    Enabled: "rgba(0, 0, 0, 0)",
    Hovered: "rgba(0, 0, 0, 0)",
    Pressed: "rgba(0, 0, 0, 0)",
    Disabled: "rgba(0, 0, 0, 0)"
  }
}, Ft = {
  primary: St,
  primarySubtle: Pt,
  primarySubtleFgDim: Bt,
  primarySubdued: Ht,
  outlinedPrimary: Tt,
  secondary: _t,
  secondaryIcWarning: mt,
  secondaryIcSupportIcon: Dt,
  secondarySubtle: Ct,
  outlinedSecondary: At,
  outlinedSecondaryIcWarning: Et,
  outlinedSecondaryIcSupportIcon: wt,
  outlinedSecondaryFgAccent: zt,
  tertiary: Lt,
  warning: $t,
  outlinedWarning: It,
  ontint: Wt,
  ontintFgAccent: Rt,
  ontintSubduedFgAccent: Ot,
  outlinedOntint: Nt,
  inverse: kt
}, y = (e) => Ft[e], L = ({
  height: e = 0,
  width: a = 1
}) => /* @__PURE__ */ l(Mt, {
  height: e,
  width: a
}), Yt = () => (e) => `${e.width}px`, Gt = () => (e) => `${e.height}px`, Mt = /* @__PURE__ */ s("div")({
  name: "Margin",
  class: "mer5ogw",
  propsAsIs: !1,
  vars: {
    "mer5ogw-0": [Yt()],
    "mer5ogw-1": [Gt()]
  }
}), N = C(function({
  normalColor: a = "primary",
  selectedColor: t = "primary",
  isDisabled: n = !1,
  isSelected: i = !1,
  buttonTypeOption: o,
  containerWidth: d,
  labelText: b = null,
  labelElipses: p,
  leftIconImage: g = null,
  rightIconImage: c = null,
  onClick: h
}, u) {
  const {
    fontWeight: H,
    lineHeight: T,
    fontSize: S
  } = O(o.font);
  return /* @__PURE__ */ l(gn, {
    ref: u,
    normalColor: a,
    selectedColor: t,
    isSelected: i,
    buttonTypeOption: o,
    fontWeight: H,
    lineHeight: T,
    fontSize: S,
    containerWidth: d,
    labelElipses: p,
    disabled: n,
    onClick: () => {
      h == null || h();
    },
    children: /* @__PURE__ */ f(cn, {
      labelElipses: !0,
      children: [g && /* @__PURE__ */ f(pn, {
        children: [g, /* @__PURE__ */ l(L, {
          width: o.gapBetweenIconAndText
        })]
      }), /* @__PURE__ */ l(yn, {
        labelElipses: p,
        children: b
      }), c && /* @__PURE__ */ f(fn, {
        children: [/* @__PURE__ */ l(L, {
          width: o.gapBetweenIconAndText
        }), c]
      })]
    })
  });
}), jt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).backgroundColor.Enabled}` : `${y(t).backgroundColor.Enabled}`, qt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).borderColor.Enabled}` : `${y(t).borderColor.Enabled}`, Ut = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).labelColor.Enabled}` : `${y(t).labelColor.Enabled}`, Vt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).iconColor.Enabled}` : `${y(t).iconColor.Enabled}`, Zt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).backgroundColor.Pressed}` : `${y(t).backgroundColor.Pressed}`, Qt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).borderColor.Pressed}` : `${y(t).borderColor.Pressed}`, Xt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).labelColor.Pressed}` : `${y(t).labelColor.Pressed}`, Kt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).iconColor.Pressed}` : `${y(t).iconColor.Pressed}`, Jt = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).backgroundColor.Disabled}` : `${y(t).backgroundColor.Disabled}`, en = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).borderColor.Disabled}` : `${y(t).borderColor.Disabled}`, rn = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).labelColor.Disabled}` : `${y(t).labelColor.Disabled}`, an = () => ({
  isSelected: e,
  selectedColor: a,
  normalColor: t
}) => e ? `${y(a).iconColor.Disabled}` : `${y(t).iconColor.Disabled}`, tn = () => ({
  buttonTypeOption: e
}) => `${e.radius}px`, nn = () => ({
  buttonTypeOption: e
}) => `${e.height}px`, on = () => ({
  buttonTypeOption: e
}) => `${e.horizontalPadding}px`, ln = () => ({
  fontWeight: e
}) => e, sn = () => ({
  lineHeight: e
}) => e, dn = () => ({
  fontSize: e
}) => e, bn = () => ({
  containerWidth: e
}) => e ? `${e}` : "auto", gn = /* @__PURE__ */ s("button")({
  name: "Button",
  class: "b11wgv4r",
  propsAsIs: !1,
  vars: {
    "b11wgv4r-0": [jt()],
    "b11wgv4r-1": [qt()],
    "b11wgv4r-2": [Ut()],
    "b11wgv4r-3": [Vt()],
    "b11wgv4r-4": [Zt()],
    "b11wgv4r-5": [Qt()],
    "b11wgv4r-6": [Xt()],
    "b11wgv4r-7": [Kt()],
    "b11wgv4r-8": [Jt()],
    "b11wgv4r-9": [en()],
    "b11wgv4r-10": [rn()],
    "b11wgv4r-11": [an()],
    "b11wgv4r-12": [tn()],
    "b11wgv4r-13": [nn()],
    "b11wgv4r-14": [on()],
    "b11wgv4r-15": [ln()],
    "b11wgv4r-16": [sn()],
    "b11wgv4r-17": [dn()],
    "b11wgv4r-18": [bn()]
  }
}), cn = /* @__PURE__ */ s("div")({
  name: "MainContainer",
  class: "m1nsfs20",
  propsAsIs: !1
}), pn = /* @__PURE__ */ s("div")({
  name: "LeftContainer",
  class: "lqj1tlj",
  propsAsIs: !1
}), un = () => ({
  labelElipses: e
}) => e ? "nowrap" : "normal", vn = () => ({
  labelElipses: e
}) => e ? "hidden" : "visible", hn = () => ({
  labelElipses: e
}) => e ? "ellipsis" : "clip", yn = /* @__PURE__ */ s("div")({
  name: "CenterContainer",
  class: "cr8zinf",
  propsAsIs: !1,
  vars: {
    "cr8zinf-0": [un()],
    "cr8zinf-1": [vn()],
    "cr8zinf-2": [hn()]
  }
}), fn = /* @__PURE__ */ s("div")({
  name: "RightContainer",
  class: "rovhrwm",
  propsAsIs: !1
}), fe = {
  xsRect: { font: "Label/Label4_SB", height: 32, radius: 6, horizontalPadding: 2, gapBetweenIconAndText: 4 },
  smRect: { font: "Label/Label3_SB", height: 40, radius: 6, horizontalPadding: 4, gapBetweenIconAndText: 4 },
  mdRect: { font: "Label/Label2_SB", height: 48, radius: 8, horizontalPadding: 8, gapBetweenIconAndText: 6 },
  lgRect: { font: "Label/Label1_SB", height: 56, radius: 8, horizontalPadding: 12, gapBetweenIconAndText: 6 },
  xsRound: { font: "Label/Label4_SB", height: 40, radius: 20, horizontalPadding: 4, gapBetweenIconAndText: 4 },
  smRound: { font: "Label/Label3_SB", height: 48, radius: 24, horizontalPadding: 8, gapBetweenIconAndText: 5 },
  mdRound: {
    font: "Label/Label2_SB",
    height: 52,
    radius: 26,
    horizontalPadding: 12,
    gapBetweenIconAndText: 6
  },
  lgRound: {
    font: "Label/Label1_SB",
    height: 56,
    radius: 28,
    horizontalPadding: 16,
    gapBetweenIconAndText: 6
  }
}, E = {
  xsRect: { font: "Label/Label4_SB", height: 32, radius: 6, horizontalPadding: 12, gapBetweenIconAndText: 4 },
  smRect: { font: "Label/Label3_SB", height: 40, radius: 6, horizontalPadding: 16, gapBetweenIconAndText: 4 },
  mdRect: { font: "Label/Label2_SB", height: 48, radius: 8, horizontalPadding: 20, gapBetweenIconAndText: 6 },
  lgRect: { font: "Label/Label1_SB", height: 56, radius: 8, horizontalPadding: 24, gapBetweenIconAndText: 6 },
  xsRound: { font: "Label/Label4_SB", height: 40, radius: 20, horizontalPadding: 16, gapBetweenIconAndText: 4 },
  smRound: { font: "Label/Label3_SB", height: 48, radius: 24, horizontalPadding: 20, gapBetweenIconAndText: 5 },
  mdRound: {
    font: "Label/Label2_SB",
    height: 52,
    radius: 26,
    horizontalPadding: 24,
    gapBetweenIconAndText: 6
  },
  lgRound: {
    font: "Label/Label1_SB",
    height: 56,
    radius: 28,
    horizontalPadding: 28,
    gapBetweenIconAndText: 6
  }
}, Zn = C(function({
  normalColor: a = "primary",
  selectedColor: t = "primary",
  isDisabled: n = !1,
  isSelected: i = !1,
  buttonType: o = "smRect",
  labelText: d = null,
  leftIconImage: b = null,
  rightIconImage: p = null,
  onClick: g
}, c) {
  return /* @__PURE__ */ l(
    N,
    {
      ref: c,
      normalColor: a,
      selectedColor: t,
      isDisabled: n,
      isSelected: i,
      buttonTypeOption: fe[o],
      containerWidth: "100%",
      labelText: d,
      labelElipses: !0,
      leftIconImage: b,
      rightIconImage: p,
      onClick: g
    }
  );
}), Qn = C(function({
  normalColor: a = "primary",
  selectedColor: t = "primary",
  isDisabled: n = !1,
  isSelected: i = !1,
  buttonType: o = "smRect",
  containerWidth: d = 132,
  labelText: b = null,
  leftIconImage: p = null,
  rightIconImage: g = null,
  onClick: c
}, h) {
  return /* @__PURE__ */ l(
    N,
    {
      ref: h,
      normalColor: a,
      selectedColor: t,
      isDisabled: n,
      isSelected: i,
      buttonTypeOption: fe[o],
      containerWidth: `${d}px`,
      labelText: b,
      labelElipses: !0,
      leftIconImage: p,
      rightIconImage: g,
      onClick: c
    }
  );
}), Xn = C(function({
  normalColor: a = "primary",
  selectedColor: t = "primary",
  isDisabled: n = !1,
  isSelected: i = !1,
  buttonType: o = "smRect",
  labelText: d = null,
  leftIconImage: b = null,
  rightIconImage: p = null,
  onClick: g
}, c) {
  return /* @__PURE__ */ l(
    N,
    {
      ref: c,
      normalColor: a,
      selectedColor: t,
      isDisabled: n,
      isSelected: i,
      buttonTypeOption: E[o],
      labelText: d,
      labelElipses: !0,
      leftIconImage: b,
      rightIconImage: p,
      onClick: g
    }
  );
}), Kn = C(function({
  borderColor: a,
  backgroundColor: t = "rgba(0, 190, 214, 1)",
  color: n = "rgba(255, 255, 255, 1);",
  disabled: i = !1,
  type: o = "lgRect",
  width: d = "auto",
  text: b,
  left: p,
  right: g
}, c) {
  const {
    fontWeight: h,
    lineHeight: u,
    fontSize: H
  } = O(E[o].font);
  return /* @__PURE__ */ l(Ln, {
    borderColor: a ?? t,
    backgroundColor: t,
    color: n,
    disabled: i,
    buttonType: o,
    width: d,
    fontWeight: h,
    lineHeight: u,
    fontSize: H,
    children: /* @__PURE__ */ f(xn, {
      children: [p && /* @__PURE__ */ f(Sn, {
        children: [p, " ", /* @__PURE__ */ l(L, {
          width: E[o].gapBetweenIconAndText
        })]
      }), /* @__PURE__ */ l(Pn, {
        children: b
      }), g && /* @__PURE__ */ f(Bn, {
        children: [/* @__PURE__ */ l(L, {
          width: E[o].gapBetweenIconAndText
        }), g]
      })]
    })
  });
}), xn = /* @__PURE__ */ s("div")({
  name: "MainContainer",
  class: "m1kl0q49",
  propsAsIs: !1
}), Sn = /* @__PURE__ */ s("div")({
  name: "LeftContainer",
  class: "l1060o3s",
  propsAsIs: !1
}), Pn = /* @__PURE__ */ s("div")({
  name: "CenterContainer",
  class: "cm6ld3q",
  propsAsIs: !1
}), Bn = /* @__PURE__ */ s("div")({
  name: "RightContainer",
  class: "r1vj1md0",
  propsAsIs: !1
}), Hn = () => ({
  borderColor: e
}) => e, Tn = () => ({
  backgroundColor: e
}) => e, _n = () => ({
  color: e
}) => e, mn = () => ({
  buttonType: e
}) => `${E[e].radius}px`, Dn = () => ({
  buttonType: e
}) => `${E[e].height}px`, Cn = () => ({
  buttonType: e
}) => `${E[e].horizontalPadding}px`, An = () => ({
  width: e
}) => e, En = () => ({
  fontWeight: e
}) => e, wn = () => ({
  lineHeight: e
}) => e, zn = () => ({
  fontSize: e
}) => e, Ln = /* @__PURE__ */ s("button")({
  name: "Button",
  class: "b1j1rshv",
  propsAsIs: !1,
  vars: {
    "b1j1rshv-0": [Hn()],
    "b1j1rshv-1": [Tn()],
    "b1j1rshv-2": [_n()],
    "b1j1rshv-3": [mn()],
    "b1j1rshv-4": [Dn()],
    "b1j1rshv-5": [Cn()],
    "b1j1rshv-6": [An()],
    "b1j1rshv-7": [En()],
    "b1j1rshv-8": [wn()],
    "b1j1rshv-9": [zn()]
  }
});
export {
  D as CDSColor,
  qn as CDSDivider,
  Zn as CDSFillButton,
  Qn as CDSFixedButton,
  O as CDSFont,
  Un as CDSLargeTitle,
  Vn as CDSSectionTitle,
  Xn as CDSWrapButton,
  Wn as Color,
  Yn as Divider,
  Rn as FixedButton,
  Nn as Input,
  Fn as LargeTitle,
  Gn as NavigationBar,
  Kn as PromotionButton,
  Mn as SectionTitle,
  Ur as Text,
  jn as TextArea,
  kn as ToolTip,
  On as WrapButton,
  ze as fontCss,
  x as getColor
};
